(function(KUtils, $, undefined) {
    var fs = {
        decimalSeparator: ",",
        thousandSeparator: " "
    };
    KUtils.formatSettings = fs;
    //funkcija KUtils.parseInt ne koristi fs !!!! matej
    
    // Math.sign nije podržan u IE.
    // Nepreporučljiva metoda rješavanja problema.
    if (!Math.sign) {
        Math.sign = function (x) {
            if( +x === x ) { // check if a number was given
                return (x === 0) ? x : (x > 0) ? 1 : -1;
            }
            return NaN;    
        };
    }
	
	KUtils.sviOdgovoriSuPotvrdni = function (odgovori){
		//kopija funckije iz KontoType - TPitanjaRes.SviOdgovoriSuPotvrdni
		if (odgovori.FbImaPitanja == true){
			var result = true;
			$.each(odgovori.FPitanja, function (key, val){
				if (val.FIsSetOdgovor){
					result = result && val.FOdgovor;
				}
			});	
		}else{
			var result = false;	
		}
		return result;
	};
	
	KUtils.btnSpinner = function(btn, start, text){
		if (start === true){
			if (typeof btn.data("khtml") === 'undefined') {
				btn.data("khtml", btn.html());
			}
			btn.attr("disabled","");
			btn.html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> ' + (text ? text : "Molimo pričekajte..."));
		}else{
			btn.removeAttr("disabled");
			btn.html(btn.data("khtml"));
		}
	}

	KUtils.StringIsEmpty = function(testStr){
	    return !(/\S/.test(testStr));
	};
    
    KUtils.decZarezUTocka = function(data){
    	return data.replace(/\s/g, "").replace(",", ".");	
    };
    
    KUtils.normalizirajData = function(data) {
		var keys = [], k = 0;
		for (var key in data) 
			keys[k++] = key;
		
		if (keys.length == 0)
			return null;
		
		var result = [];
		for (var i = 0; i < data[keys[0]].length; ++i) {
			var item = {};
			for (var j = 0; j < keys.length; ++j){
				var newItem = data[keys[j]][i];
                if(typeof newItem === "string" || newItem instanceof String){
                	newItem = KUtils.htmlTagCharsDecode(newItem);
                }    
				item[keys[j]] = newItem;
			} 				
			
			result[i] = item;		
		}	
		return result;
	
    },
    
    KUtils.busy = function(state, msgTxt) {
        if (typeof state == 'undefined')
            var state = true;
        
        if (typeof msgTxt == 'undefined')
            var msgTxt = false;
            
        var overlay = $('#activity-overlay');
        var message = overlay.find('.message');
        
        if (state) {
            if (msgTxt) {
				overlay.addClass("overlayBackgroundGrey");
                message.html(msgTxt);
                message.show();               
            } else {
				overlay.removeClass("overlayBackgroundGrey");
                message.hide();
            }
            
            overlay.fadeIn();
        } else {
            overlay.fadeOut();
        }
    };
        	
	KUtils.CheckOIB = function(oib) {
	    oib = oib.toString();
	    if (oib.length != 11) return false;
	
	    var b = parseInt(oib, 10);
	    if (isNaN(b)) return false;
	
	    var a = 10;
	    for (var i = 0; i < 10; i++) {
	        a = a + parseInt(oib.substr(i, 1), 10);
	        a = a % 10;
	        if (a == 0) a = 10;
	        a *= 2;
	        a = a % 11;
	    }
	    var kontrolni = 11 - a;
	    if (kontrolni == 10) kontrolni = 0;
	
	    return kontrolni == parseInt(oib.substr(10, 1));
	};
	
	KUtils.fillContent = function(div, page) {
		// alert("div je :"+div+" a page je :"+page);
		$('#' + div).load(page);
	};
	KUtils.prikaziError = function(xhr, st, err, elId) {
		$("#" + elId).html(xhr.responseText);
		$("#" + elId).dialog({
			width : 400,
			//height : 200,
			title : "Dogodila se greška",
			resizable : false,
			modal : true,
			autoOpen : true,
			buttons : {
				'Zatvori' : function() {
					$(this).dialog('close');
				}
			}
		});
	};
	KUtils.prikaziNemaStavke = function() {
		var dlgSt = $("<div id=\"dlg-nema-stavke\">Niste označili stavku.</div>");
		dlgSt.dialog({
			modal : true,
			title : "Upozorenje",
			buttons : {
				"U redu" : function() {
					$(this).dialog("close");
				}
			}
		});
	};
	KUtils.kreirajDialog = function(title, poruka)
	{
		var dlg = $("<div>" + poruka + "</div>");
		dlg.dialog({
			modal : true,
			title : title,
			buttons : {
				"U redu" : function() {
					$(this).dialog("close");
				}
			}
		});
	};
	
	KUtils.isInteger = function (n) {
		return $.isNumeric(n) && Math.floor(n) == n;
	};
	
	KUtils.isNumber = function(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	};
	
	KUtils.isBoolean = function (n) {
		return (typeof(n) !== "boolean");	
	};
	
	KUtils.isRGB = function(n) {
		var boje = n.split(',');
		
		if ( KUtils.isInteger(boje[0]) &&  KUtils.isInteger(boje[1]) && KUtils.isInteger(boje[2]) ){
		var r = parseInt(boje[0]);
		var g = parseInt(boje[1]);
		var b = parseInt(boje[2]);
		
		return (r < 256) && (g < 256) && (b < 256);
		}
	 
	 return false;
	};
	
	/**
	 * Dorađena funkcija zato što Number.toFixed ne daje odgovarajuće rezultate:
	 * Primjer: 0.595.toFixed(2) = 0.59
	 * To načelno JEST točno zato što je 0.595 zapravo u memoriji 0.59499999999999997335, ali problem nastaje kad nama korisnik zada 
	 * taj broj i mi ga moramo ispravno formatirati.
	 * 
	 * KUtils.toFixed koristi zaokruživanje integera i to na način da se broj prvo pretvori u oblik pogodan za zaokruživanje, a to je množenje
	 * s 10^precision. 
	 * Apliciranjem round funkcije na rezultat dobivamo željenu vrijednost integera te daljnim dijeljenjem s 10^precision dobivamo željeni broj.
	 * 
	 */	
	KUtils.toFixed = function (value, precision) {
        precision = precision || 2;
        var power = Math.pow(10, precision);
        var abs = Math.abs(value);
        var sign = Math.sign(value);
        // Bez poziva toFixed ostajemo bez .00 na kraju za cijele brojeve. 
        // Npr. KUtils.toFixed(20, 2) bi dao samo "20"
        var str = ((Math.round(abs * power) / power) * sign).toFixed(precision);
        return str;
	};
	
	KUtils.roundToTwo = function(num) {    
	    return +(Math.round(num + "e+2")  + "e-2");
	};
	
	/**
	 * Funkcija uzima u obzir KUtils.formatSettings postavke. 
	 */
	KUtils.formatFloat = function(value, precision) {
	    var str = KUtils.toFixed(value, precision);
        var x = str.split(".");
        var intPart = x[0];
        var decPart = x.length > 1 ? fs.decimalSeparator + x[1] : "";
        
        var regex = /(\d+)(\d{3})/;
        while (regex.test(intPart))
            intPart = intPart.replace(regex, "$1" + fs.thousandSeparator + "$2");
        
        str = intPart + decPart;
        return str;
	};
	
	KUtils.parseFloat = function(num) {
	    if (typeof num === "number")
	       return num;
	    if (typeof num !== "string")
	       return undefined;
	      
	    //ako u stringu postoje i ',' i '.' prvo s ljeva je thousand separatot, a drugo je decimal 
	    iOfC = num.indexOf(",");
	    iOfD = num.indexOf(".");
	    if ( (iOfC > -1) && (iOfD > -1)){
			if (iOfC < iOfD){
				num = num.replace(",", " ");	
			}else{
				num = num.replace(".", " ");	
			}
		}
	      
		num = num.replace(fs.decimalSeparator, ".");
		num = num.split(fs.thousandSeparator).join("");
		return parseFloat(num);
	};
	
	KUtils.formatInt = function (value) {
        // Mogu koristiti built-in funkciju.
        /*cs ('formatInt: '); 
        cs (value);
        cs (typeof value);*/
        
	    var str = value.toFixed(0);
	    var regex = /(\d+)(\d{3})/;
        while (regex.test(str))
            str = str.replace(regex, "$1" + fs.thousandSeparator + "$2");
        return str;
	};
	
	KUtils.parseInt = function (value) {
	    value = value.replace(/ /g, "");
	    return parseInt(value);
	};
	
	KUtils.alignLabels = function(sKlasa, minWidth) {
		var sirina = 0;
		$(sKlasa).each(function() {
			if ($(this).width() > sirina) {
				sirina = $(this).width();
			}
			;
		});
		if (!isNaN(minWidth)) {
			if (sirina < minWidth) {
				sirina = minWidth;
			}
		}
		$(sKlasa).each(function() { // loop thru all labels again to indivdually
			$(this).css('display', 'inline-block').width(sirina);
		});
	};
	
	KUtils.generateGUID = function () {
		var guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
		    var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
		    return v.toString(16);
		});
		return guid;
		
	};
	
	KUtils.isIE = function () {
		return (getInternetExplorerVersion() != -1);
	};
	
	function getInternetExplorerVersion() {
		// Returns the version of Internet Explorer or a -1
		// (indicating the use of another browser).
		var rv = -1; // Return value assumes failure.
		if (navigator.appName == 'Microsoft Internet Explorer') {
			var ua = navigator.userAgent;
			var re  = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
			if (re.exec(ua) != null)
				rv = parseFloat( RegExp.$1 );
  		}
  		return rv;
	}
	
	/** 
	 * Test je li safari 
	 * vraća true or false
	 */
		
	KUtils.isSafari = function() {
		const ua = navigator.userAgent;
		return /Safari/.test(ua) && !/Chrome|CriOS|Chromium|Android|OPR|Opera|Edg|Edge|FxiOS/.test(ua);
	};
	
	KUtils.isAndroid = function() {
    	const ua = navigator.userAgent || navigator.vendor || window.opera || '';
    	return /android/i.test(ua);
  	};
  	
  	KUtils.isMobile = function(){
	  if (typeof navigator === 'undefined') return false; // npr. SSR
	  	const ua = navigator.userAgent || navigator.vendor || window.opera || '';
	
	  	// Android detekcija
	  	const isAndroid = /android/i.test(ua);
	
	  	// iOS detekcija: klasični iPhone/iPad/iPod čvor + iPadOS (MacIntel + touch)
	  	const isiOSClassic = /iP(hone|od|ad)/i.test(ua);
	  	const isIPadOS = navigator.platform === 'MacIntel' && typeof navigator.maxTouchPoints === 'number' && navigator.maxTouchPoints > 0;
	  	const isIOS = isiOSClassic || isIPadOS;
	
		return isAndroid || isIOS;
	};
	
	KUtils.toCamelCase = function(tekst, pascal){
	  if (typeof tekst !== 'string') return '';
	  return tekst
	    .replace(/[^A-Za-z0-9]+/g, ' ')
	    .trim()
	    .split(/\s+/)
	    .filter(function (s) { return !!s; })
	    .map(function (word, i) {
	      var w = String(word).toLowerCase();
	      if (!pascal && i === 0) return w;
	      return w.charAt(0).toUpperCase() + w.slice(1);
	    })
	    .join('');
	};
	
	KUtils.toPascalCase = function(tekst){
		return KUtils.toCamelCase(tekst, true); 
	};
	
	/**
	 * Nova funkcija radi i za IE 11 i EDGE 
	 * vraća true ili false
	*/
	
	KUtils.getEdgeOrIE = function() {
 		var ua = window.navigator.userAgent;

  		// Test values; Uncomment to check result …

  		// IE 10
  		// ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
  
  		// IE 11
  		// ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
  
  		// Edge 12 (Spartan)
  		// ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
  
  		// Edge 13
  		// ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

  		var msie = ua.indexOf('MSIE ');
  		if (msie > 0) {
    		// IE 10 or older => return version number
    		//return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    		return true;
  		}

  		var trident = ua.indexOf('Trident/');
  		if (trident > 0) {
    		// IE 11 => return version number
    		//var rv = ua.indexOf('rv:');
    		//return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    		return true;  		
  		}

  		var edge = ua.indexOf('Edge/');
  		if (edge > 0) {
    		// Edge (IE 12+) => return version number
    		//return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    		return true;    		
  		}

  	// other browser
	  return false;

	};
	
	KUtils.getIE = function() {
 		var ua = window.navigator.userAgent;

  		// Test values; Uncomment to check result …

  		// IE 10
  		// ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
  
  		// IE 11
  		// ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
  
  		// Edge 12 (Spartan)
  		// ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
  
  		// Edge 13
  		// ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

  		var msie = ua.indexOf('MSIE ');
  		if (msie > 0) {
    		// IE 10 or older => return version number
    		//return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    		return true;
  		}

  		var trident = ua.indexOf('Trident/');
  		if (trident > 0) {
    		// IE 11 => return version number
    		//var rv = ua.indexOf('rv:');
    		//return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    		return true;  		
  		}

  	// other browser
	  return false;
	};	
	
	/***
	 * path?query#hash 
	 */
	KUtils.addParamToUrl = function (url, key, value) {
		key = encodeURIComponent(key);
		value = encodeURIComponent(value);
		
		var x = url.split("#");
		var hash = x.length === 2 ? "#" + x[1] : "";
		var tmp = x[0].split("?");
		var path = tmp[0];
		var query = tmp.length > 1 ? tmp[1] : "";
		
		var kvp = query !== "" ? query.split("&") : [];
		var i = kvp.length;
		var x;
		while (i--) {
			x = kvp[i].split("=");
			if (x[0] == key) {
				x[1] = value;
				kvp[i] = x.join("=");
				break;
			}
		}
		if (i < 0) {
			kvp[kvp.length] = [key,value].join("=");
		}
		
		return path + "?" + kvp.join("&") + hash;
	};
	
	/**
	 * 
		 var tests = [
		    "example.com",
		    "https://www.example.com",
		    "http://www.example.com",
		    "http://www.example.com/path?section=17",
		    "http://www.example.com/path?section=17#blalal",
		    "http://www.example.com/path?section=17&nope=1",
		    "http://www.example.com/path?section=17&nope=1#hahah",
		    "http://www.konto.hr/lbl/kak/?moj=1&view_as=json&test&ne_znam",
		    "http://www.konto.hr/lbl/kak/?moj=1&view_as=json&test&ne_znam#hahah",
		    "http://domain.com/page.html?returnurl=%2Fadmin",
		    ]; 
		    
	 */
	KUtils.getQueryFromUrl = function (url) {
		var regex = /^[^\?]+\?(.*?)(?:#.*)?$/;
		var matches = url.match(regex);
		
	    var res = {};
	    if (matches !== null && matches.length === 2) {
	        var getParams = matches[1].split("&");
	        getParams.forEach(function (param) {
	            var x = param.split("=");
	            var key = decodeURIComponent(x[0]);
	            var v = x.length === 2 ? decodeURIComponent(x[1]) : null;
	            res[key] = v;
	        });
	    }
		return res;    
	};
	
	KUtils.padLeft = function padLeft(value, n, str){
		var s = String(value);
		if (n < s.length) {
			return s;	
		}
	    return Array(n - s.length + 1).join(str || '0') + value;
	};
	
	KUtils.padRight = function padRight(value, n, str){
		var s = String(value);
		if (n < s.length) {
			return s;	
		}
	    return value + Array(n - s.length + 1).join(str || '0');
	};
	
	KUtils.intToHex = function (value, pad) {
		var num = parseInt(value);
		return KUtils.padLeft(num.toString(16), pad || 0);
	};
	
	/**
	 * Pretvara integer (Delphi TColor) u hex boju. 
	 * Treba zamijeniti prva dva i zadnja dva bytea
	 */
	KUtils.intToCssDelphi = function (value) {
		var num = parseInt(value);
		if (num < 0) {
			num += 0xFFFFFFFF + 1;
		}
		
		var opacity = 1;
		var n = KUtils.intToHex(num, 6);
		if (n.length > 6) {
			opacity = parseInt(n.substring(6), 16) / 255.0;
			n = n.substring(0, 6);
		}
		
		// Splitanje u array da bismo dobili r, g, b u hex obliku (i eventualno alpha).
		var arr = n.match(/.{2}/g); // Split svaka 2 znaka
		// Ako je duljine veće od od 6 onda postoji opacity.
		
		return "rgba(" + arr.slice(0, 3).reverse().map(function (hex) { return parseInt(hex, 16); }).join() + ", " + opacity.toFixed(3) + ")";
	};
	
	/**
	 * Pretvara string "r,g,b" u hex boju (ukoliko je "r,g,b,a") zanemaruje a. 
	 */
	KUtils.RGBToHex = function (value) {	
		var boje = value.split(',');	
		return "#" + KUtils.intToHex(boje[0],2) + KUtils.intToHex(boje[1],2) + KUtils.intToHex(boje[2],2);
	};
	
	KUtils.stringUHexBoju = function(value){
		if ( KUtils.isInteger(value) ){
			return KUtils.RGBToHex( KUtils.intToCssDelphi(value) );
		}else if ( KUtils.isRGB(value) ){
			return KUtils.RGBToHex( value );
		}else{ //potrebno provjeriti je li # hex boja
			return value;	
		}
	};
	
	KUtils.formatDate = function (d) {
		var date = d;
		if (!(d instanceof Date)) {
			date = new Date(d);
		}
		
		/*ova funkcija ne radi dobro na FF-u iz nekog razloga*/
		return kendo.toString(date, "d");
	};
	
	KUtils.parseDate = function (string) {
		return kendo.parseDate(string, "dd.MM.yyyy");
	};
	
	KUtils.formatDateTime = function (d, withSeconds) {
		if (typeof withSeconds === "undefined")
			withSeconds = false;
		var date = d;
		if (!(d instanceof Date)) {
			date = new Date(d);
		}
		return kendo.toString(date, "dd.MM.yyyy HH:mm" + (withSeconds ? ":ss" : ""));
	};
	
	KUtils.parseDateTime = function (string) {
		return kendo.parseDate(string, "dd.MM.yyyy HH:mm:ss");
	};
	
	KUtils.prviDanMjeseca = function (dateObj) {
		var date = new Date(dateObj);		
		date.setDate(1);
		return date;
	};
		
	KUtils.zadnjiDanMjeseca = function (dateObj) {
		var date = new Date(dateObj);
		var zadnjiDan = KUtils.danUMjesecu(date.getMonth(), date.getFullYear());
		date.setDate(zadnjiDan);
		return date;
	};
	
	KUtils.danUMjesecu = function (iMonth, iYear) {
	    return 32 - new Date(iYear, iMonth, 32).getDate();
	};
	
	KUtils.daysBetween = function (date1, date2) {

	    // The number of milliseconds in one day
	    var ONE_DAY = 1000 * 60 * 60 * 24;
	
	    // Convert both dates to milliseconds
	    var date1_ms = date1.getTime();
	    var date2_ms = date2.getTime();

	    // Calculate the difference in milliseconds
	    var difference_ms = date2_ms - date1_ms; //Math.abs(date1_ms - date2_ms);
	
	    // Convert back to days and return
	    return Math.round(difference_ms/ONE_DAY);
	
	};
	
	KUtils.formatedStringFromDays = function (numberOfDays) {
	    var years = Math.floor(numberOfDays / 360);
    	var months = Math.floor(numberOfDays % 360 / 30);
    	var days = Math.floor(numberOfDays % 360 % 30);

    	return years.toString().padStart(2, '0') + '.' + months.toString().padStart(2, '0') + '.' + days.toString().padStart(2, '0'); 
	};
	
	KUtils.stazUDanima = function (ggmmdd) {
		if((ggmmdd.trim() == '.  .') || (ggmmdd.trim() == '')){staz = '00.00.00';}
		else{staz = ggmmdd;}
		var stazevi = staz.split('.');
		
		if(stazevi.length == 3){return parseInt(stazevi[0])*360 + parseInt(stazevi[1])*30 + parseInt(stazevi[2]);}
		else{return 0;}
	};
	
	KUtils.isValidDate = function (d) {
        if ( Object.prototype.toString.call(d) !== "[object Date]" )
            return false;
        return !isNaN(d.getTime());
    };
    
    KUtils.prazanDatum = function (d) {
    	if (KUtils.isValidDate(d)){return KUtils.formatDate(d);}
    	else{return '';}
    };
    
    KUtils.DateURazdoblju = function(Date, DateOd, DateDo){
      return (
          ( (DateOd == null) && (DateDo == null) ) 
          ||
          ( (Date > DateOd) && (DateDo == null) )
          ||
          ( (DateOd == null) && (Date <= DateDo) )
          ||
          ( (Date >= DateOd) && (Date <= DateDo) )     
      );  
    };
	
	KUtils.formatTime = function (d, withSeconds) {
		if (typeof withSeconds === "undefined")
			withSeconds = false;		
		var date = d;
		if (!(d instanceof Date)) {
			date = new Date(d);
		}
		return kendo.toString(date, "HH:mm" + (withSeconds ? ":ss" : ""));		
	};
	
	KUtils.TimeStrToTimeFloat = function(satiStr) {
		var satiArr = satiStr.split(":");
	    if (satiArr.length == 1) {
	   		vrati = 0;
	    }			
	    else {
			var sati = parseInt(satiArr[0]);		    	
			var minute = parseInt(satiArr[1]);				
	        if(isNaN(minute)) minute = 0;	        
	        if(isNaN(sati)) sati = 0;       
	        
		   	vrati = ((sati * 60) + minute) / 60;
		}	         
		return vrati;         
	};
	
	KUtils.TimeFloatToTimeStr = function(satiFloat) {
    	var sati = Math.floor(satiFloat);
    	var minute = Math.round((satiFloat - sati) * 60);

        if(isNaN(minute)) minute = 0;	        
        if(isNaN(sati)) sati = 0;
		var satiStr = (sati < 10 ? "0" : "") + sati + ":" + (minute < 10 ? "0" : "") + minute;        
		
		return satiStr;         
	};
	
	KUtils.parseTime = function (string) {
		return kendo.parseDate(string, "HH:mm:ss");
	};
	
	KUtils.areSameDate = function(date1, date2) {
		var d1 = date1;
		var d2 = date2;
		
		if (!(date1 instanceof Date)) {
			d1 = new Date(date1);
		}
		if (!(date2 instanceof Date)) {
			d2 = new Date(date2);
		}
		
	    return d1.getFullYear() == d2.getFullYear()
	        && d1.getMonth() == d2.getMonth()
	        && d1.getDate() == d2.getDate();
	};
	
	
	/** 
	 * Funkcija dateToArray - prebacuje string timestamp u array 
	 *   ako je string prazan vrati od trenutnog datuma
	 */
	KUtils.dateToArray = function(dateString, withSeconds) 
	{	
		if (typeof withSeconds === "undefined")
			withSeconds = false;	
					
		var vrati = ["31", "12", "1999","23","59","59"];
		
		if (typeof dateString === "undefined") 
		{
			var new_date = 	KUtils.formatDateTime(new Date(), true);
		}		
		else
		{
			var new_date = dateString;
		}
		
        vrati[0] = new_date.substring(0,2); 	//dan
		vrati[1] = new_date.substring(3,5);		//mjesec
		vrati[2] = new_date.substring(6,10);	//godina
		vrati[3] = new_date.substring(11,13);	//sat
		vrati[4] = new_date.substring(14,16);	//minute
		
		if(withSeconds)
		{
			vrati[5] = new_date.substring(17,19);	//sekunde
			//ako se traži sa sekundama a sekunde nisu prosljeđene onda dodajemo 00, jer bez tog neki browseri jave error (npr. firefox)
			if (vrati[5] === ""){ 
				vrati[5] = "00"	
			}
		}	
		else
		{
			vrati[5] = "00";
		}
		
		return vrati;
	};
	
	KUtils.DateTime = function(dateString)
	{					
		dateArray = KUtils.dateToArray(dateString, true);
				
		var newDate = new Date(dateArray[2] + "-" + dateArray[1] + "-" + dateArray[0] + " " + dateArray[3] + ":" + dateArray[4] + ":" + dateArray[5]);     
		          
		if(KUtils.getIE())
		{				 
			newDate = new Date(dateArray[2] + "/" +dateArray[1] + "/" + dateArray[0] + " " + dateArray[3] + ":" + dateArray[4] + ":" + dateArray[5]);						
		}  		
		
		if(KUtils.isSafari())
		{				 
			newDate = new Date(dateArray[1] + "/" +dateArray[0] + "/" + dateArray[2] + " " + dateArray[3] + ":" + dateArray[4] + ":" + dateArray[5]);						
		} 		
		
		return newDate;
	};
	
    KUtils.Date = function(dateString)
    {                   
        dateArray = KUtils.dateToArray(dateString, false);
                
        var newDate = new Date(dateArray[2] + "-" + dateArray[1] + "-" + dateArray[0]);     
                  
        if(KUtils.getIE())
        {                
            newDate = new Date(dateArray[2] + "/" +dateArray[1] + "/" + dateArray[0]);                       
        }       
        
        if(KUtils.isSafari())
        {                
            newDate = new Date(dateArray[1] + "/" +dateArray[0] + "/" + dateArray[2]);                       
        }       
        
        return newDate;
    };
	
    KUtils.DateNotValid = function (that, date) {
    	var result = false;
    	if($(that).prop('required')){
    		result = true;
    	} 	
    	if((typeof date !== "undefined") && (date !== null)){
			var date1 = KUtils.Date("01.01.1800");
			var date2 = KUtils.Date("01.01.0100");
			var date3 = KUtils.Date("30.12.1899");								
        	result = ((date.getTime() < date1.getTime()) && (date.getTime() != date2.getTime())) || (date.getTime() == date3.getTime());
	    	if($(that).data('validacija-morabitiutekucojgodini')){
	    		result = (date.getFullYear() != ($("#aktivnaGodina").text()));
	    	}          	
       }       
       return result;       
    };
    
    KUtils.OdreziTimeZone = function(x){
		if (typeof x == "string"){
			if (x.length == 10){ // npr. '2023-01-02' (to je oblik kada je u delphie objektu TKT<Date> a ne TKT<DateTime>)
				return x + 'T00:00:00';
			}
			return x.slice(0,19); //da zanemarimo timezone	
		}  
		return x; 	
	};	
    
    KUtils.InputIsRequiredAndEmpty = function (that) {
    	var result = false;
    	var field = that.val();
    	if(that.prop('required')){
	    	if((typeof field === "undefined") || (field === null)){
	    		result = true;
	    	}
	    	else{
	    		result = (field == "")  || ($(that).hasClass('int-value') && field == 0);
	    	}    		
    	}
       return result;       
    };	 
    
    KUtils.SetRequired = function (that){
    	// $(this).closest(".form-group").after('<div class="invalid-feedback">Polje je zahtjevano.</div>'); // bootstrap 4 validacija   
    	if((that.hasAttribute("required")) && !(that.hasAttribute("readonly"))) {
    		$(that).addClass("required-field"); 	
    		var label = $(that).closest(".form-group").find("label").first();
    		if (label.length > 0){
	    		var oldText = label.html().trim();
	    		var lastChar = oldText.slice(-1);
	    		if(lastChar != "*"){
					label.html(oldText + "*");
				}
			}				
		}   		
	};   
		
	// dohvati korisničke postavke
    KUtils.getKorisnikPostavke = function(){
    	var SSName = "KorisnikPostavke_" + $("#userName").html();
	    var korisnikPostavke = simpleStorage.get(SSName);
        if (typeof(korisnikPostavke) === "undefined"){	    	
	        korisnikPostavke = KUtils.setDefaultKorisnikPostavke();
	    }
	    else {
	  		var formalnaProvjera = KUtils.formalnaProvjeraKorisnikPostavke(korisnikPostavke);
	  		if(!(formalnaProvjera)) {  			
  				korisnikPostavke = KUtils.setDefaultKorisnikPostavke();
	  		}
	    }
	    return korisnikPostavke;   
   	};	
    
    // Vrati defaultne korisničke postavke  
	KUtils.getDefaultKorisnikPostavke = function() {
		var korisnikPostavke = {};
		
		korisnikPostavke.automatskoPopunjavanjeFiltera = true;
		korisnikPostavke.automatskiPrijepisVrijednostiFiltera = true;
		korisnikPostavke.fontSize = 14;
		
		return korisnikPostavke;		
	};
	  
	KUtils.setDefaultKorisnikPostavke = function() {
    	var SSName = "KorisnikPostavke_" + $("#userName").html();		
		var korisnikPostavke = KUtils.getDefaultKorisnikPostavke();
		simpleStorage.set(SSName, korisnikPostavke);	
		
		return korisnikPostavke;
	};
		  
	KUtils.formalnaProvjeraKorisnikPostavke = function(korisnikPostavke) {
		var provjera = true;
		
		/*
		 Zbog nekog razloga provjera isInteger ne prolazi pa za sada isključujemo provjeru 
		 
		if(KUtils.isBoolean(korisnikPostavke.automatskoPopunjavanjeFiltera))
			provjera = false;
		else if(KUtils.isBoolean(korisnikPostavke.automatskiPrijepisVrijednostiFiltera))
			provjera = false;			
		else if(KUtils.isInteger(korisnikPostavke.fontSize))
			provjera = false;						
		*/
		return provjera;
	};	  
	        	
	// automatski odabir razine ovisno o izborniku u meniju
	KUtils.getUrlVar = function (key){
		var result = new RegExp(key + "=([^&]*)", "i").exec(window.location.search); 
		return result && unescape(result[1]) || ""; 
	};
	
	KUtils.getVarFromUrl = function (url, key){
		var result = new RegExp(key + "=([^&]*)", "i").exec(url); 
		return result && unescape(result[1]) || ""; 
	};	
	
	KUtils.IsKontoProgram = function(link){
		var result = false;
		if (link.indexOf("/") != -1){
			var program = link.substring(0, link.indexOf("/")).toUpperCase();
			if((program == 'VP') || (program == 'MP') || (program == 'MA') || (program == 'UG') ||
			   (program == 'AC') || (program == 'AO') || (program == 'AP') || (program == 'AS') ||
			   (program == 'BA') || (program == 'BL') || (program == 'BS') || (program == 'CV') ||
			   (program == 'EK') || (program == 'EN') || (program == 'GS') || (program == 'HR') ||
			   (program == 'KA') || (program == 'KE') || (program == 'KI') || (program == 'KO') ||
			   (program == 'KR') || (program == 'MJ') || (program == 'MK') || (program == 'NA') ||
			   (program == 'NK') || (program == 'OD') || (program == 'OK') || (program == 'OS') ||
			   (program == 'PL') || (program == 'PN') || (program == 'PP') || (program == 'PU') ||
			   (program == 'RO') || (program == 'SC') || (program == 'SD') || (program == 'SP') ||
			   (program == 'UZ') || (program == 'VI') || (program == 'VM') || (program == 'IZ') ||
			   (program == 'AU') || (program == 'NI')){
				result = true;
			}		
		}
		return result;
	};
	
	KUtils.htmlTagCharsEncode = function (str) {
	    return String(str).replace(/</g, '&lt;').replace(/>/g, '&gt;');
	};	
	
	KUtils.htmlTagCharsDecode = function (str) {
	    var map = {
	        '&lt;': '<',
	        '&gt;': '>'
	    };
	
	    return str.replace(/\&[\w\d\#]{2,5}\;/g, function(m) { return map[m]; });
	};	
		
	KUtils.htmlSpecialCharsEncode = function (str) {
	    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
	};	
	
	KUtils.htmlSpecialCharsDecode = function (str) {
	    var map = {
	        '&amp;': '&',
	        '&lt;': '<',
	        '&gt;': '>',
	        '&quot;': '"'
	    };
	
	    return str.replace(/\&[\w\d\#]{2,5}\;/g, function(m) { return map[m]; });
	};		
	
	KUtils.RemoveBannedChars = function (text){
		// (); <> + CR \ @ $ ´ “ … 

		var result = text.replace(/[()<>;+@$´“…]/g, '');	
		result = result.replace(/\x0A/g, '');
		result = result.replace(/\x0D/g, '');
		result = result.replace(/\x5C/g, '');
		return result;					
	};
		
	KUtils.RemoveTagChars = function (text){
		// <> 

		var result = text.replace(/[<>]/g, '');	
		return result;					
	};
			
		
	KUtils.getCleanUrl = function (url){
		var result = '';
		var tempUrl = decodeURIComponent((url+'').replace(/\+/g, '%20'));
		if (tempUrl.indexOf("?") != -1){
			var link = KUtils.getVarFromUrl(tempUrl, "link");
			var link2 = KUtils.RemoveBannedChars(link);
			result = tempUrl.substring(0, tempUrl.indexOf("?"));
			if(KUtils.IsKontoProgram(link2)){
				result += "?link=" + link2;	
			}					
		}
		else{
			result = tempUrl;
		}		
		return result;
	};
	
	KUtils.getDanUTjednu = function(d){
		var dan = new Array(7);
		dan[0] = "nedjelja";
		dan[1] =  "ponedjeljak";
		dan[2] = "utorak";
		dan[3] = "srijeda";
		dan[4] = "četvrtak";
		dan[5] = "petak";
		dan[6] = "subota";		
		return dan[d.getDay()];
	};
	
	/**
	 * Preuzeto sa: http://stackoverflow.com/questions/10687099/how-to-test-if-a-url-string-is-absolute-or-relative
	 * Testovi:
	 * r.test('http://example.com'); // true - regular http absolute URL
	 * r.test('HTTP://EXAMPLE.COM'); // true - HTTP upper-case absolute URL
     * r.test('https://www.exmaple.com'); // true - secure http absolute URL
     * r.test('ftp://example.com/file.txt'); // true - file transfer absolute URL
     * r.test('//cdn.example.com/lib.js'); // true - protocol-relative absolute URL
     * r.test('/myfolder/test.txt'); // false - relative URL
     * r.test('test'); // false - also relative URL
	 */
	KUtils.isAbsoluteUrl = function (url) {
		var r = new RegExp('^(?:[a-z]+:)?//', 'i');
		return r.test(url);
	};
	
	KUtils.isTextSelected = function (input) {
        if (typeof input.selectionStart == "number") {
            return input.selectionStart == 0 && input.selectionEnd == input.value.length;
        } else if (typeof document.selection != "undefined") {
            input.focus();
            return document.selection.createRange().text == input.value;
        }
    };
    
    KUtils.getInputSelection = function (el) {
        var start = 0, end = 0, normalizedValue, range,
            textInputRange, len, endRange;
    
        if (typeof el.selectionStart == "number" && typeof el.selectionEnd == "number") {
            start = el.selectionStart;
            end = el.selectionEnd;
        } else {
            range = document.selection.createRange();
    
            if (range && range.parentElement() == el) {
                len = el.value.length;
                normalizedValue = el.value.replace(/\r\n/g, "\n");
    
                // Create a working TextRange that lives only in the input
                textInputRange = el.createTextRange();
                textInputRange.moveToBookmark(range.getBookmark());
    
                // Check if the start and end of the selection are at the very end
                // of the input, since moveStart/moveEnd doesn't return what we want
                // in those cases
                endRange = el.createTextRange();
                endRange.collapse(false);
    
                if (textInputRange.compareEndPoints("StartToEnd", endRange) > -1) {
                    start = end = len;
                } else {
                    start = -textInputRange.moveStart("character", -len);
                    start += normalizedValue.slice(0, start).split("\n").length - 1;
    
                    if (textInputRange.compareEndPoints("EndToEnd", endRange) > -1) {
                        end = len;
                    } else {
                        end = -textInputRange.moveEnd("character", -len);
                        end += normalizedValue.slice(0, end).split("\n").length - 1;
                    }
                }
            }
        }

        return {
            start: start,
            end: end
        };
    };

    /**
     * Funkcija koja vraca html element zeljenih opcija
     * 
     * @param {Object} postavkeIkone
     */
    KUtils.ispisiGumb = function (postavkeGumba) {
        //defaultne vrijednosti
        var postavkeGumbaDefault = {
            wrapper: 'button', //tip wrapping elementa
            type: 'button', //button - ne ide automatsku submit
            wrapperClass: 'btn btn-light', //klasa wrapping elementa
            iconClass: 'fas fa-exclamation', //klasa elementa
            textColor: '#fff', //boja teksta
            text:'', //tekst elementa
            title:'', //title elementa  
            before:'',
            after:'',
            icon: {
            	wrapper: 'i',
            	wrapperClass: 'fas fa-file-alt',
            	textColor: '#fff'          	
            },       
        };    
                        
        //merganje defaultnih i novih vrijednosti
        var gumb = $.extend(true, {}, postavkeGumbaDefault, postavkeGumba);
        
        //ispis ikone ukoliko je definirana
        var ikona = gumb.icon ? KUtils.ispisiIkonu(gumb.icon) : '';
        
        //postavljanje title-a iz texta ako title nije definiran (samo ukoliko nije definiran)
        if (gumb.title === '')
        	gumb.title = gumb.text;
        
        return gumb.before+'<'+gumb.wrapper+' type="'+gumb.type+'" title="'+gumb.title+'" class="'+gumb.wrapperClass+'" style="color:'+gumb.textColor+'">'+ ikona + ' ' + gumb.text+'</'+gumb.wrapper+'>'+gumb.after;
              
    };
    
    /**
     * Funkcija koja vraca html element zeljenih opcija
     * 
     * @param {Object} postavkeIkone
     */
    KUtils.ispisiIkonu = function (postavkeIkone) {
        //defaultne vrijednosti
        var postavkeIkoneDefault = {
            wrapper: 'span', //tip elementa
            wrapperClass: 'fas fa-exclamation', //klasa elementa
            textColor: 'inherit', //'black', //boja teksta
            text:'', //tekst elementa
            title:'', //title elementa
            after: ' ', //nakon ikone - po defaultu jedan prazan prostor
            before: '',            
        };    
                        
        //merganje defaultnih i novih vrijednosti
        var ikona = $.extend({}, postavkeIkoneDefault, postavkeIkone);
        
        return ikona.before+'<'+ikona.wrapper+' title="'+ikona.title+'" class="'+ikona.wrapperClass+'" style="color:'+ikona.textColor+'">'+ikona.text+'</'+ikona.wrapper+'>'+ikona.after;      
    };
       
        
    /**
     * Funkcija za generiranje ikona prioriteta
     * 
     * @param {String} prioritet
     */
    KUtils.prioritetIkona = function (prioritet) {      
        switch (prioritet) {
            case "1": //hitno i vazno
                var prOpcije = {after:'', title: 'HITNO I VAZNO', textColor:'red', wrapperClass: 'prioritetIkona fas fa-angle-double-right'};
                return KUtils.ispisiIkonu(prOpcije); 
            break;
            
            case "2": //hitno            
                var prOpcije = {after:'', title: 'HITNO', textColor:'red', wrapperClass: 'prioritetIkona fas fa-angle-right'};
                return KUtils.ispisiIkonu(prOpcije);
            break;
            
            default:
            case "3": //normalno (defaultno)
                var prOpcije = {after:'', title: 'Normalno', textColor:'#538be3; font-size: 12px;', wrapperClass: 'prioritetIkona fas fa-ellipsis-h'};
                return KUtils.ispisiIkonu(prOpcije);                
            break;
           	
            case "4": //kad se stigne
                var prOpcije = {after:'', title: 'Kad se stigne', textColor:'green', wrapperClass: 'prioritetIkona fas fa-angle-left'};
                return KUtils.ispisiIkonu(prOpcije);                
            break;
            
            case "5": //kad nema drugog posla
                var prOpcije = {after:'', title: 'Kad nema drugog posla', textColor:'green', wrapperClass: 'prioritetIkona fas fa-angle-double-left'};
                return KUtils.ispisiIkonu(prOpcije); 
            break;
        }
    };

        
    /**
     * Funkcija za generiranje ikona prioriteta
     * 
     * @param {String} prioritet
     */
    KUtils.prioritetOznaka = function (prioritet) {    
    	var prOpcije_default = {containerKlasa: 'priority-container'}; 
    	var prOpcije = {};
    	 
        switch (prioritet) {
            case "1": //hitno i vazno
                prOpcije = {title: 'HITNO I VAZNO', text: 'KRITIČNO!', klasa: 'priority-critical'};
            break;
            
            case "2": //hitno            
                prOpcije = {title: 'HITNO', text: 'HITNO!',  klasa: 'priority-high'};
            break;
            
            default:
            case "3": //normalno (defaultno)
                prOpcije = {title: 'Normalno', text: 'Normalan', klasa: 'priority-normal'};
            break;
           	
            case "4": //kad se stigne
                prOpcije = {title: 'Kad se stigne', text: 'Niski',  klasa: 'priority-low'};
            break;
            
            case "5": //kad nema drugog posla
                prOpcije = {title: 'Kad nema drugog posla', text: 'Nije prioritet', klasa: 'priority-none'};
            break;
        }
        
        var prOpcije = $.extend({}, prOpcije_default, prOpcije);
        return '<div class="'+prOpcije.containerKlasa+'"><span class="'+prOpcije.klasa+'" title="'+prOpcije.title+'">'+prOpcije.text+'</span></div>';
    };
    
        
    /**
     * Funkcija za generiranje ikona opcija
     * 
     * @param {String} prioritet
     */        
    KUtils.opcijeIkona = function (opcije) {
        var output = '';
        var title = '';
        var naplaceno = 0;
        var platiti = 0;
        var sati = '';
        
        $.each(opcije, function(opcija, value) {
            if (value != 1)
            	return;
            	
            switch (opcija) {
                case "ugovorOOdrzavanju": 
                	title = 'B - Partner ima ugovor o održavanju (besplatno) u trenutku dok je posao otvoren';            
                    output += KUtils.ispisiIkonu({title: title, textColor:'#0852ee', wrapperClass: 'far fa-list-alt'});
                break;    
                                       
                case "inciraoKonto": 
                	title = 'K - Posao je inicirao KONTO (a ne korisnik)';
                    output += KUtils.ispisiIkonu({title: title, textColor:'#450404', wrapperClass: 'far fa-heart'});
                break;
                
                case "radniNalog": 
                	title = 'R - Posao je radni nalog';
                    output += KUtils.ispisiIkonu({title: title, textColor:'black', wrapperClass: 'fas fa-car'});
                break;
                
                case "onLine": 
                	title = 'L - Posao je on line';
                    output += KUtils.ispisiIkonu({title: title, textColor:'black', wrapperClass: 'fas fa-globe'});
                break;
                
                case "obilazakKorisnika": 
                	title = 'O - Posao je obilazak korisnika';
                    output += KUtils.ispisiIkonu({title: title, textColor:'black', wrapperClass: 'fas fa-rocket'});
                break;
                
                case "ponavljajuci": 
                	title = 'p - Posao je ponavljanje';
                    output += KUtils.ispisiIkonu({title: title, textColor:'black', wrapperClass: 'fas fa-redo'});
                break;
                
                case "ponovljeni": 
                	title = 'W - Posao je nastao ponavljanjem';										 
                    output += KUtils.ispisiIkonu({title: title, textColor:'black', wrapperClass: 'fas fa-level-down-alt'});
                break;
                
                case "platiti": //P
                    platiti = 1;  
				break;
				                                    
                case "naplaceno": //N 
                    naplaceno = 1;                                     
                break;
                
                case "garancijskiSati": 
                    sati += "<span title='G - garancijski sati'>G</span>";                                    
                break;
                
                case "evidencijskiSati": 
                    sati += "<span title='E - evidencijski sati'>E</span>";                                      
                break;

                case "adaptivniSati": 
                    sati += "<span title='A - adaptivni sati'>A</span>";                                      
                break;                
                 
            }
        });
        
        if ((platiti == 1) && (naplaceno == 0))
        {
            title = 'Posao treba naplatiti';        	
        	output += KUtils.ispisiIkonu({title: title, textColor: 'red', wrapperClass: 'fas fa-dollar-sign'});
        }
        else
        {
        	if ((platiti != 0) || (naplaceno != 0)) 
        	{
        		title = '';
                if(platiti != 0) title += 'Posao treba naplatiti';
                if((platiti != 0) && (naplaceno != 0)) title += ' - ';
                if(naplaceno != 0) title += 'Posao je naplaćen';                
                        		
				output += KUtils.ispisiIkonu({title: title, textColor: 'black', wrapperClass: 'fas fa-dollar-sign'});        		
        	}        	
        }        
        if (sati != '') output += sati;
        return output;

    };    
    
    /**
     * Funkcija za generiranje ikona oznaka aplikacije
     * 
     * @param {String} prioritet
     */            
    KUtils.oznakaAplikacijeIkona = function (oznaka) {     
        var title = oznaka;
        //ako pocinje s W - win, brisemo prvo slovo
        if (oznaka.charAt(0) == 'W') {
            oznaka = oznaka.substr(1);
        }
            
        return KUtils.ispisiIkonu({
        	text: title, 
        	title: title, 
        	wrapper:'div', 
        	wrapperClass: 'oznaka-aplikacije '+oznaka.toLowerCase()
        });           
    };
    
    
    /**
     * Funkcija za generiranje dnevnog passworda
     */
    KUtils.akcijeGumbi = function (brisanje) { 
    	var brisanje = (typeof brisanje !== 'undefined') ? brisanje : 0;
		
		brisanje = 1; //privremeni override
		
		if (brisanje)
    		return KUtils.ispisiIkonu({
    			title: 'Obriši posao', 
    			wrapper:'a', 
    			wrapperClass: 'brisiPosaoBtn fas fa-times-circle'
    		});           
   	};
   	
   	    
    /**
     * Funkcija za generiranje dnevnog passworda
     */
    KUtils.generateKontoPass = function () { 
    	var d = new Date();
    	return (99-d.getDate())+''+(99-d.getMonth());
   	};
    
    /**
     * Funkcija koja za keyCode vraća da li je printable character.
     * http://stackoverflow.com/questions/12467240/determine-if-javascript-e-keycode-is-a-printable-non-control-character
     * 
     * @param {Integer}
     */
    KUtils.isKeyCodePrintable = function (keycode) {
        return (keycode > 47 && keycode < 58)   || // number keys
            keycode == 32 || keycode == 13   || // spacebar & return key(s) (if you want to allow carriage returns)
            (keycode > 64 && keycode < 91)   || // letter keys
            (keycode > 95 && keycode < 112)  || // numpad keys
            (keycode > 185 && keycode < 193) || // ;=,-./` (in order)
            (keycode > 218 && keycode < 223);   // [\]' (in order)     
    };
    
    
    KUtils.camelCase = function(str) {
    	if (typeof str === 'undefined')
    		return;
    		
	  	return str.replace(/^([A-Z])|[\s-_](\w)/g, function(match, p1, p2, offset) {
	        if (p2) return p2.toUpperCase();
	        return p1.toLowerCase();        
	    });
	};
	
    KUtils.unCamelCase = function(str) {
	    return str
	        // insert a space between lower & upper
	        .replace(/([a-z])([A-Z])/g, '$1 $2')
	        // space before last upper in a sequence followed by lower
	        .replace(/\b([A-Z]+)([A-Z])([a-z])/, '$1 $2$3').toLowerCase()
	        // uppercase the first character
	        .replace(/^./, function(str){ return str.toUpperCase(); });	        
	};
	
	KUtils.convertToSlug = function(txt) {
		//ovo nije prikladno za tekst koji koristi nase dijakritike jer uklanja ta slova
		//tada je potrebno koristiti KUtils.convertToLatinizedSlug
	    return txt
	        .toLowerCase()
	        .replace(/[^\w ]+/g,'')
	        .replace(/ +/g,'-');
	};
	
	KUtils.convertToLatinizedSlug = function(txt, lowercase) {
		//pretvara slova sa dijakriticima u njihove ne-dijakriticke oblike
		//šđčćž u sdccz		
		txt = txt.latinize();
	    
   	    var $slug = '';
	    var trimmed = $.trim(txt);
		    $slug = trimmed
		    	.replace(/[^a-z0-9-]/gi, '-')
		    	.replace(/-+/g, '-')
		    	.replace(/^-|-$/g, '');
		
		if (lowercase)
			return $slug.toLowerCase();
		else
	    	return $slug;
	};
	
	KUtils.delphiToPHPClassName = function (delphiClass) {
		var regex = /Konto\.DB\.(\w\w)\.\w+\.T(\w+)/i;
		var matches = delphiClass.match(regex);
		if (matches.length === 3) {
			return "Konto\\" + matches[1].toUpperCase() + "\\" + matches[2]; 
		}
		return null;
	};
	 
	 /**
	  *  String repeat - osnovni ne radi u IE tj javlja grešku  
	  */
	String.prototype.KUtilsrepeat = function( num )
	{
    	return new Array( num + 1 ).join( this );
	};	 
	    
	 /**
	  *  Izbacuje sekunde iz stringa koji je full timestamp npr. "17.05.2017 12:34:56"
	  *  može imati i milisekunde :P ako baš neko želi
	  */
	String.prototype.KUtilsIzbaciSekunde = function()
	{
		var new_string = this.trim();
		
    	if(this.length > 16)
    	{
    		new_string = new_string.substring(0,16);
    	}
    	
    	return new_string;
	};	 	    
	    
    /**
     * Jednostavna funkcija za trim/truncate string
     * 
     * @param {Integer} 
     */
    String.prototype.trimToLength = function(m) {
      return (this.length > m) 
        ? jQuery.trim(this).substring(0, m).split(" ").slice(0, -1).join(" ") + "..."
        : this;
    };
    
    /**
     * Funkcija za kapitalizaciju prvog slova
     */
    String.prototype.capitalizeFirstLetter = function() {
	    return this.charAt(0).toUpperCase() + this.slice(1);
	};
	       
	/**
	 * Funkcija za sjeckanje stringa na dijelove 
	 */       
   	String.prototype.chunk = function(n) {
	    var ret = [];
	    for(var i=0, len=this.length; i < len; i += n) {
	       ret.push(this.substr(i, n));
	    }
	    return ret;
	};
	
	// Array Remove - By John Resig (MIT Licensed)
	Array.prototype.remove = function(from, to) {
	  	var rest = this.slice((to || from) + 1 || this.length);
	  	this.length = from < 0 ? this.length + from : from;
	  	return this.push.apply(this, rest);
	};
	
	// latinize
	var Latinise={};Latinise.latin_map={"Á":"A","Ă":"A","Ắ":"A","Ặ":"A","Ằ":"A","Ẳ":"A","Ẵ":"A","Ǎ":"A","Â":"A","Ấ":"A","Ậ":"A","Ầ":"A","Ẩ":"A","Ẫ":"A","Ä":"A","Ǟ":"A","Ȧ":"A","Ǡ":"A","Ạ":"A","Ȁ":"A","À":"A","Ả":"A","Ȃ":"A","Ā":"A","Ą":"A","Å":"A","Ǻ":"A","Ḁ":"A","Ⱥ":"A","Ã":"A","Ꜳ":"AA","Æ":"AE","Ǽ":"AE","Ǣ":"AE","Ꜵ":"AO","Ꜷ":"AU","Ꜹ":"AV","Ꜻ":"AV","Ꜽ":"AY","Ḃ":"B","Ḅ":"B","Ɓ":"B","Ḇ":"B","Ƀ":"B","Ƃ":"B","Ć":"C","Č":"C","Ç":"C","Ḉ":"C","Ĉ":"C","Ċ":"C","Ƈ":"C","Ȼ":"C","Ď":"D","Ḑ":"D","Ḓ":"D","Ḋ":"D","Ḍ":"D","Ɗ":"D","Ḏ":"D","ǲ":"D","ǅ":"D","Đ":"D","Ƌ":"D","Ǳ":"DZ","Ǆ":"DZ","É":"E","Ĕ":"E","Ě":"E","Ȩ":"E","Ḝ":"E","Ê":"E","Ế":"E","Ệ":"E","Ề":"E","Ể":"E","Ễ":"E","Ḙ":"E","Ë":"E","Ė":"E","Ẹ":"E","Ȅ":"E","È":"E","Ẻ":"E","Ȇ":"E","Ē":"E","Ḗ":"E","Ḕ":"E","Ę":"E","Ɇ":"E","Ẽ":"E","Ḛ":"E","Ꝫ":"ET","Ḟ":"F","Ƒ":"F","Ǵ":"G","Ğ":"G","Ǧ":"G","Ģ":"G","Ĝ":"G","Ġ":"G","Ɠ":"G","Ḡ":"G","Ǥ":"G","Ḫ":"H","Ȟ":"H","Ḩ":"H","Ĥ":"H","Ⱨ":"H","Ḧ":"H","Ḣ":"H","Ḥ":"H","Ħ":"H","Í":"I","Ĭ":"I","Ǐ":"I","Î":"I","Ï":"I","Ḯ":"I","İ":"I","Ị":"I","Ȉ":"I","Ì":"I","Ỉ":"I","Ȋ":"I","Ī":"I","Į":"I","Ɨ":"I","Ĩ":"I","Ḭ":"I","Ꝺ":"D","Ꝼ":"F","Ᵹ":"G","Ꞃ":"R","Ꞅ":"S","Ꞇ":"T","Ꝭ":"IS","Ĵ":"J","Ɉ":"J","Ḱ":"K","Ǩ":"K","Ķ":"K","Ⱪ":"K","Ꝃ":"K","Ḳ":"K","Ƙ":"K","Ḵ":"K","Ꝁ":"K","Ꝅ":"K","Ĺ":"L","Ƚ":"L","Ľ":"L","Ļ":"L","Ḽ":"L","Ḷ":"L","Ḹ":"L","Ⱡ":"L","Ꝉ":"L","Ḻ":"L","Ŀ":"L","Ɫ":"L","ǈ":"L","Ł":"L","Ǉ":"LJ","Ḿ":"M","Ṁ":"M","Ṃ":"M","Ɱ":"M","Ń":"N","Ň":"N","Ņ":"N","Ṋ":"N","Ṅ":"N","Ṇ":"N","Ǹ":"N","Ɲ":"N","Ṉ":"N","Ƞ":"N","ǋ":"N","Ñ":"N","Ǌ":"NJ","Ó":"O","Ŏ":"O","Ǒ":"O","Ô":"O","Ố":"O","Ộ":"O","Ồ":"O","Ổ":"O","Ỗ":"O","Ö":"O","Ȫ":"O","Ȯ":"O","Ȱ":"O","Ọ":"O","Ő":"O","Ȍ":"O","Ò":"O","Ỏ":"O","Ơ":"O","Ớ":"O","Ợ":"O","Ờ":"O","Ở":"O","Ỡ":"O","Ȏ":"O","Ꝋ":"O","Ꝍ":"O","Ō":"O","Ṓ":"O","Ṑ":"O","Ɵ":"O","Ǫ":"O","Ǭ":"O","Ø":"O","Ǿ":"O","Õ":"O","Ṍ":"O","Ṏ":"O","Ȭ":"O","Ƣ":"OI","Ꝏ":"OO","Ɛ":"E","Ɔ":"O","Ȣ":"OU","Ṕ":"P","Ṗ":"P","Ꝓ":"P","Ƥ":"P","Ꝕ":"P","Ᵽ":"P","Ꝑ":"P","Ꝙ":"Q","Ꝗ":"Q","Ŕ":"R","Ř":"R","Ŗ":"R","Ṙ":"R","Ṛ":"R","Ṝ":"R","Ȑ":"R","Ȓ":"R","Ṟ":"R","Ɍ":"R","Ɽ":"R","Ꜿ":"C","Ǝ":"E","Ś":"S","Ṥ":"S","Š":"S","Ṧ":"S","Ş":"S","Ŝ":"S","Ș":"S","Ṡ":"S","Ṣ":"S","Ṩ":"S","Ť":"T","Ţ":"T","Ṱ":"T","Ț":"T","Ⱦ":"T","Ṫ":"T","Ṭ":"T","Ƭ":"T","Ṯ":"T","Ʈ":"T","Ŧ":"T","Ɐ":"A","Ꞁ":"L","Ɯ":"M","Ʌ":"V","Ꜩ":"TZ","Ú":"U","Ŭ":"U","Ǔ":"U","Û":"U","Ṷ":"U","Ü":"U","Ǘ":"U","Ǚ":"U","Ǜ":"U","Ǖ":"U","Ṳ":"U","Ụ":"U","Ű":"U","Ȕ":"U","Ù":"U","Ủ":"U","Ư":"U","Ứ":"U","Ự":"U","Ừ":"U","Ử":"U","Ữ":"U","Ȗ":"U","Ū":"U","Ṻ":"U","Ų":"U","Ů":"U","Ũ":"U","Ṹ":"U","Ṵ":"U","Ꝟ":"V","Ṿ":"V","Ʋ":"V","Ṽ":"V","Ꝡ":"VY","Ẃ":"W","Ŵ":"W","Ẅ":"W","Ẇ":"W","Ẉ":"W","Ẁ":"W","Ⱳ":"W","Ẍ":"X","Ẋ":"X","Ý":"Y","Ŷ":"Y","Ÿ":"Y","Ẏ":"Y","Ỵ":"Y","Ỳ":"Y","Ƴ":"Y","Ỷ":"Y","Ỿ":"Y","Ȳ":"Y","Ɏ":"Y","Ỹ":"Y","Ź":"Z","Ž":"Z","Ẑ":"Z","Ⱬ":"Z","Ż":"Z","Ẓ":"Z","Ȥ":"Z","Ẕ":"Z","Ƶ":"Z","Ĳ":"IJ","Œ":"OE","ᴀ":"A","ᴁ":"AE","ʙ":"B","ᴃ":"B","ᴄ":"C","ᴅ":"D","ᴇ":"E","ꜰ":"F","ɢ":"G","ʛ":"G","ʜ":"H","ɪ":"I","ʁ":"R","ᴊ":"J","ᴋ":"K","ʟ":"L","ᴌ":"L","ᴍ":"M","ɴ":"N","ᴏ":"O","ɶ":"OE","ᴐ":"O","ᴕ":"OU","ᴘ":"P","ʀ":"R","ᴎ":"N","ᴙ":"R","ꜱ":"S","ᴛ":"T","ⱻ":"E","ᴚ":"R","ᴜ":"U","ᴠ":"V","ᴡ":"W","ʏ":"Y","ᴢ":"Z","á":"a","ă":"a","ắ":"a","ặ":"a","ằ":"a","ẳ":"a","ẵ":"a","ǎ":"a","â":"a","ấ":"a","ậ":"a","ầ":"a","ẩ":"a","ẫ":"a","ä":"a","ǟ":"a","ȧ":"a","ǡ":"a","ạ":"a","ȁ":"a","à":"a","ả":"a","ȃ":"a","ā":"a","ą":"a","ᶏ":"a","ẚ":"a","å":"a","ǻ":"a","ḁ":"a","ⱥ":"a","ã":"a","ꜳ":"aa","æ":"ae","ǽ":"ae","ǣ":"ae","ꜵ":"ao","ꜷ":"au","ꜹ":"av","ꜻ":"av","ꜽ":"ay","ḃ":"b","ḅ":"b","ɓ":"b","ḇ":"b","ᵬ":"b","ᶀ":"b","ƀ":"b","ƃ":"b","ɵ":"o","ć":"c","č":"c","ç":"c","ḉ":"c","ĉ":"c","ɕ":"c","ċ":"c","ƈ":"c","ȼ":"c","ď":"d","ḑ":"d","ḓ":"d","ȡ":"d","ḋ":"d","ḍ":"d","ɗ":"d","ᶑ":"d","ḏ":"d","ᵭ":"d","ᶁ":"d","đ":"d","ɖ":"d","ƌ":"d","ı":"i","ȷ":"j","ɟ":"j","ʄ":"j","ǳ":"dz","ǆ":"dz","é":"e","ĕ":"e","ě":"e","ȩ":"e","ḝ":"e","ê":"e","ế":"e","ệ":"e","ề":"e","ể":"e","ễ":"e","ḙ":"e","ë":"e","ė":"e","ẹ":"e","ȅ":"e","è":"e","ẻ":"e","ȇ":"e","ē":"e","ḗ":"e","ḕ":"e","ⱸ":"e","ę":"e","ᶒ":"e","ɇ":"e","ẽ":"e","ḛ":"e","ꝫ":"et","ḟ":"f","ƒ":"f","ᵮ":"f","ᶂ":"f","ǵ":"g","ğ":"g","ǧ":"g","ģ":"g","ĝ":"g","ġ":"g","ɠ":"g","ḡ":"g","ᶃ":"g","ǥ":"g","ḫ":"h","ȟ":"h","ḩ":"h","ĥ":"h","ⱨ":"h","ḧ":"h","ḣ":"h","ḥ":"h","ɦ":"h","ẖ":"h","ħ":"h","ƕ":"hv","í":"i","ĭ":"i","ǐ":"i","î":"i","ï":"i","ḯ":"i","ị":"i","ȉ":"i","ì":"i","ỉ":"i","ȋ":"i","ī":"i","į":"i","ᶖ":"i","ɨ":"i","ĩ":"i","ḭ":"i","ꝺ":"d","ꝼ":"f","ᵹ":"g","ꞃ":"r","ꞅ":"s","ꞇ":"t","ꝭ":"is","ǰ":"j","ĵ":"j","ʝ":"j","ɉ":"j","ḱ":"k","ǩ":"k","ķ":"k","ⱪ":"k","ꝃ":"k","ḳ":"k","ƙ":"k","ḵ":"k","ᶄ":"k","ꝁ":"k","ꝅ":"k","ĺ":"l","ƚ":"l","ɬ":"l","ľ":"l","ļ":"l","ḽ":"l","ȴ":"l","ḷ":"l","ḹ":"l","ⱡ":"l","ꝉ":"l","ḻ":"l","ŀ":"l","ɫ":"l","ᶅ":"l","ɭ":"l","ł":"l","ǉ":"lj","ſ":"s","ẜ":"s","ẛ":"s","ẝ":"s","ḿ":"m","ṁ":"m","ṃ":"m","ɱ":"m","ᵯ":"m","ᶆ":"m","ń":"n","ň":"n","ņ":"n","ṋ":"n","ȵ":"n","ṅ":"n","ṇ":"n","ǹ":"n","ɲ":"n","ṉ":"n","ƞ":"n","ᵰ":"n","ᶇ":"n","ɳ":"n","ñ":"n","ǌ":"nj","ó":"o","ŏ":"o","ǒ":"o","ô":"o","ố":"o","ộ":"o","ồ":"o","ổ":"o","ỗ":"o","ö":"o","ȫ":"o","ȯ":"o","ȱ":"o","ọ":"o","ő":"o","ȍ":"o","ò":"o","ỏ":"o","ơ":"o","ớ":"o","ợ":"o","ờ":"o","ở":"o","ỡ":"o","ȏ":"o","ꝋ":"o","ꝍ":"o","ⱺ":"o","ō":"o","ṓ":"o","ṑ":"o","ǫ":"o","ǭ":"o","ø":"o","ǿ":"o","õ":"o","ṍ":"o","ṏ":"o","ȭ":"o","ƣ":"oi","ꝏ":"oo","ɛ":"e","ᶓ":"e","ɔ":"o","ᶗ":"o","ȣ":"ou","ṕ":"p","ṗ":"p","ꝓ":"p","ƥ":"p","ᵱ":"p","ᶈ":"p","ꝕ":"p","ᵽ":"p","ꝑ":"p","ꝙ":"q","ʠ":"q","ɋ":"q","ꝗ":"q","ŕ":"r","ř":"r","ŗ":"r","ṙ":"r","ṛ":"r","ṝ":"r","ȑ":"r","ɾ":"r","ᵳ":"r","ȓ":"r","ṟ":"r","ɼ":"r","ᵲ":"r","ᶉ":"r","ɍ":"r","ɽ":"r","ↄ":"c","ꜿ":"c","ɘ":"e","ɿ":"r","ś":"s","ṥ":"s","š":"s","ṧ":"s","ş":"s","ŝ":"s","ș":"s","ṡ":"s","ṣ":"s","ṩ":"s","ʂ":"s","ᵴ":"s","ᶊ":"s","ȿ":"s","ɡ":"g","ᴑ":"o","ᴓ":"o","ᴝ":"u","ť":"t","ţ":"t","ṱ":"t","ț":"t","ȶ":"t","ẗ":"t","ⱦ":"t","ṫ":"t","ṭ":"t","ƭ":"t","ṯ":"t","ᵵ":"t","ƫ":"t","ʈ":"t","ŧ":"t","ᵺ":"th","ɐ":"a","ᴂ":"ae","ǝ":"e","ᵷ":"g","ɥ":"h","ʮ":"h","ʯ":"h","ᴉ":"i","ʞ":"k","ꞁ":"l","ɯ":"m","ɰ":"m","ᴔ":"oe","ɹ":"r","ɻ":"r","ɺ":"r","ⱹ":"r","ʇ":"t","ʌ":"v","ʍ":"w","ʎ":"y","ꜩ":"tz","ú":"u","ŭ":"u","ǔ":"u","û":"u","ṷ":"u","ü":"u","ǘ":"u","ǚ":"u","ǜ":"u","ǖ":"u","ṳ":"u","ụ":"u","ű":"u","ȕ":"u","ù":"u","ủ":"u","ư":"u","ứ":"u","ự":"u","ừ":"u","ử":"u","ữ":"u","ȗ":"u","ū":"u","ṻ":"u","ų":"u","ᶙ":"u","ů":"u","ũ":"u","ṹ":"u","ṵ":"u","ᵫ":"ue","ꝸ":"um","ⱴ":"v","ꝟ":"v","ṿ":"v","ʋ":"v","ᶌ":"v","ⱱ":"v","ṽ":"v","ꝡ":"vy","ẃ":"w","ŵ":"w","ẅ":"w","ẇ":"w","ẉ":"w","ẁ":"w","ⱳ":"w","ẘ":"w","ẍ":"x","ẋ":"x","ᶍ":"x","ý":"y","ŷ":"y","ÿ":"y","ẏ":"y","ỵ":"y","ỳ":"y","ƴ":"y","ỷ":"y","ỿ":"y","ȳ":"y","ẙ":"y","ɏ":"y","ỹ":"y","ź":"z","ž":"z","ẑ":"z","ʑ":"z","ⱬ":"z","ż":"z","ẓ":"z","ȥ":"z","ẕ":"z","ᵶ":"z","ᶎ":"z","ʐ":"z","ƶ":"z","ɀ":"z","ﬀ":"ff","ﬃ":"ffi","ﬄ":"ffl","ﬁ":"fi","ﬂ":"fl","ĳ":"ij","œ":"oe","ﬆ":"st","ₐ":"a","ₑ":"e","ᵢ":"i","ⱼ":"j","ₒ":"o","ᵣ":"r","ᵤ":"u","ᵥ":"v","ₓ":"x"};
	String.prototype.latinise=function(){return this.replace(/[^A-Za-z0-9\[\] ]/g,function(a){return Latinise.latin_map[a]||a; });};
	String.prototype.latinize=String.prototype.latinise;
	String.prototype.isLatin=function(){return this==this.latinise();};
	
	
	KUtils.generirajCDSTablicu = function (rows) {
		var table = '';
		var tblHeaders = '';
		var tblData = '';
		var resetData = true;
		
		// ruzan kod... ne ponosim se njime... ali posluzit ce do daljnjega
		if (!empty (rows)) {
			var tblColumn = [];
			
			$.each(rows, function (key, val) {
				tblHeaders += '<th>'+KUtils.unCamelCase(key).capitalizeFirstLetter()+'</th>';
				
				$.each(val, function (key2, val2) {
					if(resetData){
						tblColumn[key2] = '';
					}
					tblColumn[key2] = tblColumn[key2]+'<td>'+val2+'</td>';
				});
				resetData = false;	
			});

			//iteriramo i dodajemo row-ove
	
			$.each(tblColumn, function(key,val) {
				tblData += '<tr class="data">'+val+'</tr>';
			});
			tblHeaders = '<tr class="headers">'+tblHeaders+'</tr>';
			table = '<table style="width: 100%;"><tbody>' + tblHeaders + tblData + '</tbody></table>';
		} else {
			table = '<p>Nema zapisa u povijesti promjena.</p>';
		}
		return table;
	};
	
	
	KUtils.defaultAjaxErrorHandler = function (event, jqXHR, ajaxSettings, thrownError) {
		if (thrownError == "abort") 
	        return;
		
		// dodana mogućnost override-a globalnog hendlanja responsa
		if (jqXHR.statusText == "errorOverride") 
	        return;	    

		// network error, nema mrežne konekcije
		if (jqXHR.readyState == 0)
			return;

		var content = "";
		// Provjera redirect
		var location = jqXHR.getResponseHeader("Redirect-Location");
		if (typeof location === "string" && location.length) {
		    var reloadPage = jqXHR.getResponseHeader("Reload-Page") === "1";
		    reloadPage ? window.location.replace(location) : kontorouter.goto(location);
		    return;
		}
		
		if (jqXHR.responseText) {
			// Možda je naša greška, pa treba provjeriti da li je JSON i error
			try {
				var data = $.parseJSON(jqXHR.responseText);
				if (data && data.error) {
					content = data.error;	
				}
				// Znam... seljački
				if (data.error == "Session expired") {
					kontorouter.goto("login");
					return;
				}
				
				if (data.errorType === "SessionExpired") {
				    konto.dialogs.login({
				        template: data.loginLink
				    });
				    return;
				}
			}
			catch (e) { }
		}
		// Ako nije zadan content, napiši generičku poruku greške.
		if (!content) {
			content = "Neuspjelo dohvaćanje podataka.<br />";
			if (ajaxSettings.url)
				content += "Url: " + ajaxSettings.url + "<br />";
			content += "Tip greške: " + thrownError + "<br />";
			content += "Status: " + jqXHR.status + " " + jqXHR.statusText + "<br />";
			if (jqXHR.responseText) {
				content += "Odgovor servera: " + jqXHR.responseText + "<br />";
			}
		}
		var title = "Obavijest";
		if (ajaxSettings && ajaxSettings.errorTitle)
			title = ajaxSettings.errorTitle;
		konto.dialogs.greska({
			title: title,
			bgHeaderColorClass: "bg-danger text-white",
			content: content,
			top: "50px",
			width: "650px"
		});	
	};
	
/**
 * Funkcija koja generira key-value listu objekata nad nekom listom objekata
 * 
 * @param {Object} data
 * @param {String} keyField
 */
	KUtils.generirajKeyValue = function(data, keyField, sluggize) {
		var retData = {};
		
		if (data !== null)
			for (var i = 0; i < data.length; i++) {
				var key = data[i][keyField];
				
				if (isset(sluggize) && sluggize === true)
					key = KUtils.convertToSlug(key);
				
				retData[key] = data[i];
			}
		
		return retData;
	};
/**
 * Funkcija koja vraća true/false obzirom na to da li 'data' sadrzi 'char'
 * ( po dafaultu je case sensitive )
 * 
 * @param {String} data
 * @param {String} char
 * @param {Bool} caseInSensitive
 */
	KUtils.imaOpciju = function(data, chr, caseInSensitive) {
		if (chr.length === 0) return false;
	//funkcija je kopija funkcije -> c:\konto\nasljedi\wproc.ImaOpciju  (ali drugačiji je redosljed parametara!)	
		//ako je case insensitive
		if (typeof caseInsensitive !== 'undefined')
			if (caseInSensitive == true)
				chr = chr.toUpperCase();
		
		if(data.indexOf(chr) === -1) 
			return false;
		else
			return true;
	};
	
/**
 * Funkcija koja vraća updatan string opcija
 * 
 * @param {String} opcije
 * @param {String} opcija
 * @param {Bool} bInOrOut
 */
	KUtils.updateOpcije = function(opcije, opcija, bInOrOut) {
	//funkcija je kopija funkcije -> c:\konto\nasljedi\wproc.UpdateOpcije
		if ( bInOrOut ){
			if (opcije.indexOf(opcija) === -1 ){
				opcije = opcije + opcija;
				return opcije;
			}
		}else{
			return opcije.replace(opcija, "");	
		}
		
	};

    KUtils.naljepnicePrikazi = function(options){
        var rows = options.rows;
        var cols = options.cols;
		var naslov = options.naslov ? options.naslov : "Odaberite početnu poziciju ispisa";
        $.dialog({
            title: naslov,
            width: "600px",
            content: function () {
                var num = 0;
                var table = $("<table>");
                table.addClass("table table-bordered naljepnice");
                for (i = 0; i < rows; i++) {
                    var colStr = "";
                    for (j = 0; j < cols; j++) {
                        num++;
                        colStr = colStr + "<td><a href='#'>" + num + "</a></td>";
                    }
                    table.append("<tr>" + colStr + "</tr>");
                }
                $("a", table).each(function (index, element) {
                    $(element).click(function () {
                        options.method(this.text);
                        $(this).closest(".modal").modal("hide");
                    });
                });
                return table;
            }
        });                                                                                                               
    };
    
    /*
     * funkcija je kopija funkcije TPartnerBL.GetMapaZaDokumenteZaOtvoriti(const csMapaZaDokumente: string): string;
     * zbog specifičnosti weba mapaDefault se ne dohvača u funkciji već se prosljeđuje
     */  
    KUtils.partnerGetMapaZaDokumenteZaOtvoriti = function(csMapaZaDokumente, mapaDefault){                 
        if (csMapaZaDokumente == ""){
            return mapaDefault;
        } else {
       		return csMapaZaDokumente; 	
        }                                                                                                                           
    }; 
	
    KUtils.setFontSize = function(size) {
        $("body").css("font-size", size + "px");
        $(".fontSizeProperty").css("font-size", size + "px");
        
        $.cookie("font-size", size, { path: "{{$cookieRoot}}" });
    };	
    
    KUtils.getFontSize = function(){
        var fontSize = $.cookie("font-size");
        if (!fontSize) {
            fontSize = 14;
        }
        return fontSize;   	
    };	
	KUtils.getBrowser = function(){
	    var ua=navigator.userAgent,tem,M=ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []; 
	    if(/trident/i.test(M[1])){
	        tem=/\brv[ :]+(\d+)/g.exec(ua) || []; 
	        return {name:'IE',version:(tem[1]||'')};
	    }   
	    if(M[1]==='Chrome'){
	        tem=ua.match(/\bOPR\/(\d+)/);
	        if(tem!=null) {return {name:'Opera', version:tem[1]};}
	    }   
	    
	    M=M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
	    if((tem=ua.match(/version\/(\d+)/i))!=null) {M.splice(1,1,tem[1]);}
	    
	    return {
	      	name: M[0],
      		version: M[1]
	    };
	};
	
	//vraća niz[ stlye, polja] -> polja = [] su niz polja na koja se primjenjuje stlye, ako je prazan, onda se primjenje na cijeli red
	KUtils.izgledStatusaUStlye = function(izgledStatusa){
		var zaWeb = izgledStatusa.split(";");

		var stlye="";
		var fields = [];
		for (i = 0; i < zaWeb.length; i++) {
    		if (zaWeb[i].indexOf("FONT.COLOR") != -1){
    			var temp = zaWeb[i].split("=")[1];
    			if (temp != "")
    				stlye = "COLOR=" + temp + ";";	
    		}else if (zaWeb[i].indexOf("FONT.STYLE") != -1){
    			var temp = zaWeb[i].split("=")[1];
    			if (temp != "")
    				stlye = stlye + "FONT_STYLE=" + temp + ";";	   				
    		}else if (zaWeb[i].indexOf("BACKGROUND.COLOR") != -1){
    			var temp = zaWeb[i].split("=")[1];
    			if (temp != "")
    				stlye = stlye + "BACKGROUND-COLOR=" + temp + ";";
    		}else if (zaWeb[i].indexOf("APPLY_FIELDS") != -1){
    			var temp = zaWeb[i].split("=")[1];	
    			if (temp!="")
    				fields = temp.split(",");
    		} 			
		}
		return [stlye,fields];			
	};
	
	KUtils.wordWrapToStringList = function(text, maxLength) {
	    var result = [], line = [];
	    var length = 0;
	    text.split(" ").forEach(function(word) {
	        if ((length + word.length) >= maxLength) {
	            result.push(line.join(" "));
	            line = []; length = 0;
	        }
	        length += word.length + 1;
	        line.push(word);
	    });
	    if (line.length > 0) {
	        result.push(line.join(" "));
	    }
	    return result;
	};
		
	KUtils.setReadonlyRB = function(selektor){
		$(selektor)
			.each(function(){
		        if (!($(this)[0].checked))
		        $(this).attr("disabled", true);    
		    });		
	};
	
	KUtils.overrideCss = function(el, propName, value){
		var style = el.attr('style');	
		if (style){
			var over = false;
			var styleArr = style.split(';');
			for (i=0; i<styleArr.length; i++){
				if (styleArr[i].trim() == propName ){
					styleArr[i] = value;
					over = true;				
				}
			}
			if (!over){ //nije pronađena, i-1 je uvijek prazno zbog formata cssa
				styleArr[i-1] = propName+':'+value;
			}
			
			el.attr('style', styleArr.join(';'));	
		}else{
			el.attr('style', propName+':'+value);	
		}
		return el;
	};
	
	//SND - search and destroy 
	KUtils.SNDFormType = function(stringifyData){
		//form-type definiran je u unos-base, tako da ako postoji na prvom je mjestu u formi.
		try{
			var pos = stringifyData.indexOf('form-type');		
			if (pos == 0){
				return stringifyData.substring(17);
			}
			return stringifyData;	
		} catch (e){
			return stringifyData;	
		}	
	};
	
	KUtils.ObojiCell = function(sif, rowEl, aCell, boja, bg_c) {
        if (aCell) {
            for (var i = 0; i < aCell.length; ++i) {
                var column = sif.getCell(rowEl, aCell[i]);
                if (column) {
                    column.css(bg_c, boja); //"color" "background-color"
                }
            }
        }
        
   };
   
   KUtils.IsprazniCelije = function (grid, rowEl, aCell) {
		if (aCell) {
		    for (var i = 0; i < aCell.length; ++i) {
		        var column = grid.getCell(rowEl, aCell[i]);
		        if (column) {
		            column.html("");
		        }
		    }
		}
   };
    
    KUtils.arrayDataToStringify = function(data){
        var sendData = [];
        var i = 0;

        //podaci
        $.each(data, function(key, obj) {
            sendData[i++] = obj; 
        });

        return JSON.stringify({data: sendData}); 
    };
    
    KUtils.stringImaVodeciRazmak = function(str){
		return str[0] === ' ';	
	};
	
    KUtils.stringImaPrateciRazmak = function(str){
		return str[str.length-1] === ' ';	
	};
	
	KUtils.upozoriNaVodeceRazmake = function(polje){
		var valu = polje.val();
		if (KUtils.stringImaVodeciRazmak(valu)){			
			konto.dialogs.upit({
				content: "Upisali ste razmak prije teksta, što vjerojatno nije namjerno. Ispraviti?",
				potvrdi: function(e){
					this.close();
					var trimVal = valu.trimStart();
					if (KUtils.stringImaPrateciRazmak(valu)){
						trimVal = valu.trimEnd();		
					}
					polje.val(trimVal);
					var fakeE = jQuery.Event('keydown', { which: 9, keyCode: 9, key: 'Tab', code: 'Tab' });
					polje.trigger(fakeE);
				},
				odustani: function(e){
					this.close();
					if (KUtils.stringImaPrateciRazmak(valu)){
						var trimVal = valu.trimEnd();
						polje.val(trimVal);		
					}
					var fakeE = jQuery.Event('keydown', { which: 9, keyCode: 9, key: 'Tab', code: 'Tab' });
					polje.trigger(fakeE);
				}
			});
		}else if (KUtils.stringImaPrateciRazmak(valu)){
			var trimVal = valu.trimEnd();
			polje.val(trimVal);	
		}
	};
		
}(window.KUtils = window.KUtils || {}, jQuery));


/**
 *----------------------------------------------
 * Neke globalne cesto koristene funkcije
 * (da si malo olaksamo zivot s javascriptom)
 * ---------------------------------------------
 */


/**
 * Funkcija koja provjerava da li varijable definirana
 */
	isset = function(obj) { return !(typeof obj === 'undefined'); };

/**
 * Funkcija koja provjerava da li je varijabla prazna
 */
	empty = function (mixed_var) {
		var key;
	 	if (mixed_var === "" || mixed_var === 0 || mixed_var === "0" || mixed_var === null || mixed_var === false || typeof mixed_var === 'undefined') return true; 
	    if (typeof mixed_var == 'object') { for (key in mixed_var) { return false; } return true; } return false;
	};

/**
 * Console.log short format
 */
	//cs = function(tekst) { console.log(tekst); };
	cs = function(tekst) { console.log('%c'+tekst, 'background: red; color: white'); if (typeof tekst === 'object') console.log(tekst); };

/**
 * Debug 'cs' - ispisuje samo ako je debugMode ukljucen
 */
	if (typeof debugMode == 'undefined')
		debugMode = true;
	csd = function(tekst) { if (isset(debugMode) && debugMode === true) { console.log('%c'+tekst, 'background: #222; color: #bada55');}};


/**
 * Poziv javascript funkcije - naziv u varijabli
 *  
 */
KUtils.runFunction = function(lsFunctionName, lavFunctionArguments)
{
	//window["functionName"]();
	//namspace["functionName"](); npr. unos['mojaFunkcija']();
	var lsUnique = $(window).data("windowUnique");
	var lsDivId = "functionCall-" + lsUnique;
	var lsFunctionArguments = "";	
	
	if(typeof lavFunctionArguments != "undefined")
	{
		if(lavFunctionArguments instanceof Event)
		{
			var lsFunctionCall = "<script language='javascript'>" + lsFunctionName + "(window.event); </script>";				
		}
		else
		{
			var lavFunctionArguments2 = lavFunctionArguments.split(",");
			lsFunctionArguments = lavFunctionArguments2[0];
		
			for(i=1; i<lavFunctionArguments2.length; i++) lsFunctionArguments += ", " + lavFunctionArguments2[i];
			var lsFunctionCall = "<script language='javascript'>" + lsFunctionName + "(" + lsFunctionArguments + "); </script>";				
		}
	}
	else
	{
		var lsFunctionCall = "<script language='javascript'>" + lsFunctionName + "(); </script>";		
	}
	
	$("<div id='" + lsDivId + "' ></div>").appendTo(document.body);

	$("#" + lsDivId).html(lsFunctionCall);
	
	$("#" + lsDivId).remove();
};

/**
 * Dummy funkcija za probe
 *  
 */
KUtils.Dummy = function() {			
	cs("Dummy kaže hvala na pozivu!");
};	

/**
 * Izvlači zadanu vrijednsot iz parametara u formatu "param=vrijednost;param2=vrijednost2;" Ako je ne nađe vraća prazan string  
 * Ne podržava razmake...  param=vrijednost; param2=vrijednost2;  - nije pravilno zadan
 * strParamText je KTO1=1252;KTO2=1166220;IZV=50;
 * strParam je KTO1     
 * rezultat je 1252
 */
KUtils.GetValueFromParamText = function(strParamText, strParam){
	if (strParamText.indexOf(strParam) >= 0) {	
        var PozStart = strParamText.indexOf(strParam) + strParam.length + 1;
        var PozEnd = strParamText.indexOf(";", PozStart);
        return strParamText.substring(PozStart, PozEnd);
	}
	return "";		
};	

/**
 * Kreira objekt iz parametara formata "param=vrijednost;param2=vrijednost2;" Ako parametri nisu zadani vraća prazan objekt.  
 * Ne podržava razmake...  param=vrijednost; param2=vrijednost2;  - nije pravilno zadan
 * rezultat je {param:vrijednost, param2:vrijednost2}
 */
KUtils.GetObjectFromParamText = function(strParamText){
	var obj ={};
	if (strParamText){
		var arr = strParamText.split(';');
		for (i=0; i<arr.length-1; i++) //zadnji je prazan
		{
			var temp = arr[i].split('=');
			var key = temp[0];
			var val = temp[1];
			obj[key] = val;			
		}	
	}
	return obj;
};

/**
 * Ako imamo item koji je u containeru sa scroll barom (horizontalnim), scrola do njega tako da on bude vidljiv
 * @param {Object} container
 * @param {Object} item
 */
KUtils.setScrollHorizontal = function(container, item){
	if (item.offset() && container.offset()){
	    container.scrollLeft(
	        item.offset().left - container.offset().left + container.scrollLeft()
	    );
	}
};

/**
 * Ako imamo item koji je u containeru sa scroll barom (verikalnim), scrola do njega tako da on bude vidljiv
 * @param {Object} container
 * @param {Object} item
 */
KUtils.setScrollVertical = function(container, item){
	if (item.offset() && container.offset()){
	    container.scrollTop(
	        (item.offset().top/2) - (container.offset().top/2) + container.scrollTop()
	    );
    }
};

/**
 * Funkcija koja zadano zadano polje postavlja na enable/disable (što je na webu zapravo readonly), dodaje potrebne klase za bojanje i kursor. 
 * Potrebna dok se generalno ne riješe klase za checkbox, dropdownlist i datume
 * @param {Object} poljeE
 * @param {Object} enabled
 */
KUtils.EnableField= function(poljeE, enabled){
       if ( (poljeE.length == 1) && (poljeE.is('input:text')) ){
             poljeE.prop("readonly", !enabled);    
       }else if( (poljeE.length == 1) && (!poljeE.is('input')) ){ //checkbox                  
            if (enabled){
                poljeE.first().removeClass('nonClickable').parent().removeClass('cursorNotAllowed');
            }else{
                poljeE.first().addClass('nonClickable').parent().addClass('cursorNotAllowed');    
            }           
       }else if( poljeE.find('.konto-dropdownlist').length > 0){ //dropdownlist
            if (enabled){
                poljeE.removeClass('select-readonly').removeClass('nonClickable').parent().removeClass('cursorNotAllowed');    
            }else{
                poljeE.addClass('select-readonly').addClass('nonClickable').parent().addClass('cursorNotAllowed');   
            }       
       }else if (poljeE.find('.konto-input-date').length > 0){ //datumi
           if (enabled){
               poljeE.removeClass('date-readonly').removeClass('nonClickable').parent().removeClass('cursorNotAllowed');    
           }else{
               poljeE.addClass('date-readonly').addClass('nonClickable').parent().addClass('cursorNotAllowed');   
           }  
       }else if (poljeE.is('input:radio')){
       		poljeE.each(function(){
		        if (!($(this)[0].checked))
		        	$(this).attr("disabled", !enabled);    
		    });	     	
       }	
};

/**
 * Funkcija mijenja znak u stringu na poziciji "index", sa "replacment" 
 * @param {Object} index
 * @param {Object} replacement
 */
KUtils.replaceAtStr = function(str, index, replacement) {
    var temp = str.split('');
    temp[index] = replacement;
    return temp.join('');
};

/**
 * Impelmentacija desktop funckije VpProc.Spoji2Mema
 * @param {Object} prvi
 * @param {Object} drugi
 */
KUtils.spoji2Mema = function(prvi, drugi){
	if (prvi == ''){
		return drugi;
	}else if (drugi == ''){
		return prvi;
	}else{
		return prvi + '\n' + drugi;
	}
};
	
	KUtils.StopAllEvents = function(e) {
		e.preventDefault();
		e.stopPropagation();
		e.stopImmediatePropagation();
	};

	KUtils.GetERacunStatusCode = function(csNameStatusa){
		var map = {
			'NeSaljeSe' : '0',
        	'SaljeSe' : '1',
        	'SlanjeUTijeku' : '2',
        	'UPripremi' : '10',
        	'UValidaciji' : '20', // 20 In validation - Document is successfully uploaded, pending recipient company data validation
        	'Poslan' : '30',
        	'Dostavljen' : '40',
        	'Ispisan' : '45',
        	'IstekloVrijeme' : '50',
        	'NeuspjeloSlanje' : '51',
        	'Storniran' : '60',
        	'Prihvacen' : '70',
        	'Odbijen' : '71',
        	'Placen' : '72',
        	'ParcijalnoPlacen' : '73',
        	'PoslanUEIzvjestavanje' : '80',
        	'NeSaljeSeUEIzvjestavanje' : '81'
	    };	
	    
  	    return map[csNameStatusa]; 
	};
	
	KUtils.GetERacunStatusF2Code = function(csNameStatusa){
		var map = {
			'NijeOdredjenStatusF2' : 0,
        	'UspjesnoF2Fiskaliziran' : 1,
        	'PoslanUEIzvjestavanje' : 1,
        	'NeuspjesnoFiskaliziran' : 3
	    };	
	    
  	    return map[csNameStatusa]; 
	};
	
	KUtils.GetERacunStatusColorClass = function(csCodeStatusa){
		var result = 'eRacunStatusNeSaljeSe';
	    if(csCodeStatusa == KUtils.GetERacunStatusCode('SaljeSe')){
			result = 'eRacunStatusSaljeSe'; // clWebLightYellow;
		}
	    else if(csCodeStatusa == KUtils.GetERacunStatusCode('SlanjeUTijeku')){
	    	result = 'eRacunStatusSlanjeUTijeku'; // clWebDarkOrange;	
	    }
	    else if(csCodeStatusa == KUtils.GetERacunStatusCode('UValidaciji')){
	  	    result = 'eRacunStatusUValidaciji'; // clWebYellow;  	
	    }
	    else if(csCodeStatusa == KUtils.GetERacunStatusCode('Poslan')){
	    	result = 'eRacunStatusPoslan'; // clWebPaleGreen;
	    } 
	    else if(csCodeStatusa == KUtils.GetERacunStatusCode('Dostavljen')){
	    	result = 'eRacunStatusDostavljen'; // clWebDarkTurquoise;
	    } 
	    else if(csCodeStatusa == KUtils.GetERacunStatusCode('Ispisan')){
	    	result = 'eRacunStatusIspisan'; // clWebLightBlue;	
	    }
	    else if(csCodeStatusa == KUtils.GetERacunStatusCode('NeuspjeloSlanje')){
	    	result = 'eRacunStatusNeuspjeloSlanje'; // clWebLightCoral;
	    }
	    else if(csCodeStatusa == KUtils.GetERacunStatusCode('IstekloVrijeme')){
	    	result = 'eRacunStatusIstekloVrijeme'; // clWebLightCoral;
	    } 
	    else if(csCodeStatusa == KUtils.GetERacunStatusCode('Prihvacen')){
	    	result = 'eRacunStatusPrihvacen'; // clWebCornFlowerBlue;	
	    }
	    else if(csCodeStatusa == KUtils.GetERacunStatusCode('Odbijen')){
	    	result = 'eRacunStatusOdbijen'; // clWebRed;
	    } 
	    else if(csCodeStatusa == KUtils.GetERacunStatusCode('Placen')){
	    	result = 'eRacunStatusPlacen'; // clWebRoyalBlue;
	    } 
	    else if(csCodeStatusa == KUtils.GetERacunStatusCode('ParcijalnoPlacen')){
	    	result = 'eRacunStatusParcijalnoPlacen'; // clWebRoyalBlue;
	    } 	
	    else if(csCodeStatusa == KUtils.GetERacunStatusCode('PoslanUEIzvjestavanje')){
	    	result = 'eRacunStatusPoslanUEIzvjestavanje'; // clWebSilver;
	    } 
	    else if(csCodeStatusa == KUtils.GetERacunStatusCode('NeSaljeSeUEIzvjestavanje')){
	    	result = 'eRacunStatusNeSaljeSeUEIzvjestavanje'; // clWebLightSkyBlue;
	    } 	
		return result;
	};
	
	KUtils.GetERacunStatusF2ColorClass = function(csCodeStatusa){
		var result = 'eRacunStatusNeSaljeSe';
	    if(csCodeStatusa == KUtils.GetERacunStatusF2Code('UspjesnoF2Fiskaliziran')){
	    	result = 'eRacunStatusPoslan'; // clWebPaleGreen;	
	    }
	    else if(csCodeStatusa == KUtils.GetERacunStatusF2Code('PoslanUEIzvjestavanje')){
	  	    result = 'eRacunStatusPoslanUEIzvjestavanje'; // clWebSilver;  	
	    }
	    else if(csCodeStatusa == KUtils.GetERacunStatusF2Code('NeuspjesnoFiskaliziran')){
	    	result = 'eRacunStatusNeuspjeloSlanje'; // clWebLightCoral;
	    }  		
		return result;
	};
	
	KUtils.SetSifarnikLink = function (sifarnikLinkName, sifarnikLinkContent){    	
		sessionStorage.setItem(sifarnikLinkName, sifarnikLinkContent);       		
	};
	
	KUtils.GetSifarnikLink = function (sifarnikLinkName){    	
		return sessionStorage.getItem(sifarnikLinkName);       		
	};
	
	KUtils.fixFilterRowColumnsAfterReorder = function(e){
		var field1 = e.sender.columns[e.newIndex].field;
		var field2 = e.sender.columns[e.oldIndex].field;
		
		var after = false;
		if (e.newIndex > e.oldIndex){
			after = true;	
		} 

		//mora ići preko sendera zbog toga jer može biti više gridova na pregledu
	    var row = e.sender.element.find('tr.k-filter-row.k-table-row.konto-filter-row'); 
	    var th1 = row.find('th[data-field="' + field1 + '"]');
  		var th2 = row.find('th[data-field="' + field2 + '"]');
		if (!th1.length || !th2.length || th1.is(th2)) return false;
	    if (after == true){
			th1.after(th2);	
		}else{
			th1.before(th2);	
		}
		
	  	return true;
	};
	
	KUtils.RemoveGetParamsFromSifarnikLink = function (){		
        var izboriId = $("#izboriId").html(); 
        var izboriNewTabId = $('body').data('izboriNewTabId');                  
       	var sifarnikLinkName = "SifarnikLink_" + izboriId + '_' + izboriNewTabId;        	
    	var linkCache = KUtils.GetSifarnikLink(sifarnikLinkName);

        var lastLink = null;
        if (linkCache)
            lastLink = $.parseJSON(linkCache);	
        var location = null;
        if (lastLink)
            location = lastLink.link;
            
         if(location){
         	var pos = location.indexOf('?');
         	var newLocation = location.substring(0, pos);	
         	history.pushState({}, null, newLocation);
         	KUtils.SetSifarnikLink(sifarnikLinkName, JSON.stringify({       
                link: newLocation,
                controller: this.controller,
                action: this.actionName,
                baseAction: this.baseActionName,
                relative: this.controller + "/" + this.baseActionName,
            }));
         } 		
	};
	
	KUtils.MakeHtmlFromParams = function (params){
		const paramsArray = params.split("&");
		
		var newHtml = '';
		for(i=0; i<paramsArray.length; i++){
			var elPair = paramsArray[i].split("=");
			
			newHtml = newHtml + "<input type='hidden' name='" + elPair[0] + "' value='" + elPair[1] + "' >";
		}
		
		return newHtml;
	};
	
	KUtils.menuIconMap = function(){
		return {
                "1": "far fa-file-alt",
                "2": "fas fa-file-invoice",
                "3": "fas fa-hand-holding-usd",
                "4": "fas fa-star",
                "5": "fas fa-calculator",
                "6": "far fa-clipboard",
                "7": "fas fa-user",
                "8": "fas fa-boxes",
                "9": "fas fa-phone",
                "10": "fas fa-tools",
                "11": "fas fa-folder",
                "12": "fas fa-book-open",
                "13": "fas fa-balance-scale",
                "14": "fas fa-palette",
                "15": "fas fa-chart-pie",
                "16": "far fa-calendar-alt",
                "17": "fas fa-user-lock",
                "18": "fas fa-car-side",
                "19": "far fa-image",
                "20": "fas fa-file-download",
                "21": "fas fa-sync-alt",
                "22": "fas fa-users",
                "23": "fas fa-chart-bar",
                "24": "far fa-question-circle",
                "25": "fas fa-archive",
                "26": "fas fa-home",
                "27": "fas fa-key",
                "28": "far fa-file-excel",
                "29": "fas fa-step-backward",
                "30": "fas fa-arrow-left",
                "31": "fas fa-arrow-right",
                "32": "fas fa-step-forward",
                "33": "fas fa-barcode",
                "34": "fas fa-save",
                "35": "fas fa-long-arrow-alt-left",
                "36": "fas fa-long-arrow-alt-right",
                "37": "fas fa-search",
                "38": "fas fa-print",
                "39": "far fa-file-pdf",
                "40": "fas fa-check",
                "41": "fas fa-times",
                "42": "fas fa-plus",
                "43": "fas fa-minus",
                "44": "fas fa-pencil-alt",
                "45": "fas fa-cut",
                "46": "fas fa-ban",
                "47": "fas fa-binoculars",
                "48": "fas fa-location-arrow",
                "49": "fas fa-copy",
                "50": "fas fa-exclamation-triangle",
                "51": "fas fa-undo",
                "52": "fas fa-redo",
                "53": "far fa-comment-alt",
                "54": "far fa-comments",
                "55": "far fa-dot-circle",
                "56": "fas fa-hdd",
                "57": "far fa-copy",
                "58": "fas fa-file-export",
                "59": "far fa-clone",
                "60": "far fa-list-alt",
                "61": "far fa-envelope",
                "62": "far fa-window-maximize",
                "63": "fas fa-caret-up",
                "64": "fas fa-caret-down",
                "65": "fas fa-recycle",
                "66": "fas fa-inbox",
                "67": "fas fa-box-open",
                "68": "far fa-file",
                "69": "far fa-arrow-alt-circle-left",
                "70": "fas fa-arrow-circle-down",
                "71": "far fa-arrow-alt-circle-down",
                "72": "fas fa-cogs",
                "73": "far fa-file-image",
                "74": "fas fa-table",
                "75": "fas fa-search-plus",
                "76": "fas fa-filter",
                "77": "fas fa-tasks",
                "78": "far fa-window-close",
                "79": "fas fa-file",
                "80": "fas fa-angle-double-down",
                "81": "fas fa-walking",
                "82": "fas fa-sign-out-alt",
                "83": "fas fa-clipboard-list",
                "84": "fas fa-building",
                "85": "fas fa-tags",
                "86": "fas fa-eye",
                "87": "fas fa-file-video",
                "88": "fas fa-book",
                "89": "fas fa-cube",
                "90": "fas fa-laptop-house",
                "91": "fas fa-folder-open",
                "92": "fas fa-user-check",
                "93": "fas fa-signature",
                "94": "fas fa-file-import",
                "95": "fas fa-truck",
                "96": "fas fa-layer-group",
                "97": "fas fa-route",
                "98": "fas fa-file-signature",
                "99": "fas fa-id-card",
                "100": "fas fa-graduation-cap",
                "101": "fas fa-star-half-alt",
                "102": "fas fa-umbrella-beach",
                "103": "fas fa-money-check-alt",
                "104": "fas fa-file-invoice-dollar",
                "105": "fas fa-shopping-cart",
                "106": "fas fa-chart-pie",
                "107": "fas fa-chart-area",
                "108": "fas fa-wallet",
                "109": "fas fa-file-contract",
                "110": "fas fa-exclamation-circle",
                "111": "fas fa-user-tag",
                "112": "fas fa-user-tie",
                "113": "fas fa-edit",
                "114": "fas fa-briefcase",
                "115": "fas fa-bed",
                "116": "fas fa-bullhorn",
                "117": "fas fa-user-plus",
                "118": "fas fa-user-edit",
                "119": "fas fa-lock",
                "120": "fas fa-balance-scale-right",
                "121": "fas fa-money-check",
                "122": "fas fa-map-marked-alt",
				"123": "fas fa-chart-line",
            };
	};
	
	KUtils.MemoUpdateDeleteSection = function (inputString, sectionName, newContent) { // generirao ChatGPT
	    // Create a regex pattern to match the desired section
	    const regex = new RegExp("(\\[" + sectionName + "\\]\\s*)([\\s\\S]*?)(?=\\[|$)", "g");
	    
	    // If newContent is empty, remove the section if it exists
	    if (!newContent) {
	        return inputString.replace(regex, "").replace(/^\s*[\r\n]/gm, ""); // Remove the section and any empty lines left behind
	    }
	
	    // Replace the matched content with the new content
	    const updatedString = inputString.replace(regex, "$1" + newContent.trim() + "\n");
	
	    // If no replacement was made, that means the section didn't exist
	    if (inputString === updatedString) {
	        // Create a new section with new content
	        return updatedString + "\n[" + sectionName + "]\n" + newContent.trim() + "\n";
	    }
	
	    // Ensure there is a newline before the next section
	    return updatedString.replace(/\n{2,}/g, "\n\n"); // Make sure there is always one blank line between sections
	};
	
	KUtils.MemoReadSection = function (inputString, sectionName) { // generirao ChatGPT        	
        // Create a regex pattern to capture the desired section using double quotes
	    const regex = new RegExp("\\[" + sectionName + "\\]\\s*([\\s\\S]*?)(?=\\[|$)", "g");    				
	    const match = regex.exec(inputString);

	    // If a match is found, return the trimmed content; otherwise, return empty string
	    return match ? match[1].trim() : '';              
	};
	
	KUtils.ispisPreviewHTML = function (pdfUrl) {
		if (KUtils.isSafari()){			
	  		var prikazi =  
				'<div id="pdfWrapper" style="height:100%;width:100%;position:relative;">'+
				  '<iframe id="pdfFrame" title="PDF dokument" width="1" height="1" style="border:0; display:block; width:100%; height:100%; min-height:100vh;" loading="lazy"></iframe>' +
				  '<div id="pdfFallback" style="display:none;padding:1rem;">' +
				    '<p>Ne može se prikazati PDF unutar stranice. Ukoliko se ne radi o PDF izvješću, potražite ga u svom Preuzimanja/Downloads mapi/folderu. Hvala. <br></p>' +
				    '<a id="pdfLink" href="' + pdfUrl + '" target="_blank" rel="noopener noreferrer">Otvori/preuzmi u novom tabu</a>' +
				  '</div>' +
				'</div>' +
				
				'<script>(function(){'+
				  'const pdfUrl = "' + pdfUrl + '";' +
				  'const iframe = document.getElementById("pdfFrame");' +
				  'const fallback = document.getElementById("pdfFallback");' +
				  'const pdfLink = document.getElementById("pdfLink");' +
				  'const openBtn = document.getElementById("openBtn");' +
				
				  'pdfLink.href = pdfUrl;' +
				
				  'function expandIframe() {' +
				    'iframe.style.width = "100%";' +
				    'iframe.style.height = "100%";' +
                    'iframe.style.minHeight = "100vh";' +
                    'fallback.style.display = "none";' +
				    'hideFallback("PDF uspješno učitan")' +
				  '}' +
				
				  'function showFallback(reason) {' +
				    'console.warn("PDF fallback aktiviran:", reason);' +
				    'fallback.style.display = "block";' +			    
				  '}' +
				  
				  'function hideFallback(reason) {' +
				    'console.warn("PDF fallback sakriven:", reason);' +
				    'fallback.style.display = "none";' +
				  '}' +
				
				  // flag koji govori je li src blob URL koji smo kreirali
				  'let usedBlob = false;' +
				  'let loadTimeout = null;' +
				  'let fallbackScheduled = null;' +
				
				  // load handler: ponašanje ovisi o tome je li korišten blob
				  'iframe.addEventListener("load", () => {' +
				    // Ako je blob, load = uspjeh
				    'if (usedBlob) {' +
				      'clearTimeout(loadTimeout);' +
				      'expandIframe();' +
				      'fallback.style.display = "none";' +
				      'return;' +
				    '}' +
				
				    // Ako nije blob, pokušaj provjeriti same-origin pristup dokumentu
				    'try {' +
				      'const doc = iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document);' +
				      // Ako možemo pristupiti i dokument ima sadržaja -> vjerojatno uspješno učitano
				      'if (doc && doc.body && doc.body.childElementCount > 0) {' +
				        'clearTimeout(loadTimeout);' +
				        'expandIframe();' +
				        'fallback.style.display = "none";' +
				        'return;' +
				      '}' +
				      // Ako je dokument prazan, tretiraj kao neuspjeh
				      'clearTimeout(loadTimeout);' +
				      'showFallback("iframe loaded but document empty (likely blocked)");' +
				    '} catch (e) {' +
				      // Ako baci izuzetak -> cross-origin, ne možemo sigurno znati
				      // Schedule fallback shortly: ako embed stvarno radi korisnik će vidjeti sadržaj,
				      // ali u mnogim slučajevima embedding je blokiran pa treba pokazati fallback.
				      'clearTimeout(loadTimeout);' +
				      // Ako želiš biti konzervativniji, produlji timeout; ovdje koristimo 3s
				      'fallbackScheduled = setTimeout(() => {' +
				        'showFallback("iframe load (cross-origin) — could be blocked by X-Frame-Options / CSP");' +
				      '}, 3000);' +
				    '}' +
				  '}, { once: true });' +
				
				  'iframe.addEventListener("error", () => {' +
				    'clearTimeout(loadTimeout);' +
				    'if (fallbackScheduled) clearTimeout(fallbackScheduled);' +
				    'showFallback("iframe error event");' +
				  '}, { once: true });' +
				
				  // pokušaj fetch->blob (najpouzdanije ako origin/CORS dopušta)
				  'function tryFetchAsBlob() {' +
				    'return fetch(pdfUrl, { method: "GET", credentials: "same-origin" })' +
				      '.then(resp => {' +
				        'if (!resp.ok) throw new Error("HTTP status " + resp.status);' +
				        'return resp.blob();' +
				      '})' +
				      '.then(blob => {' +
				        'const blobUrl = URL.createObjectURL(blob);' +
				        'usedBlob = true;' +
				        'iframe.src = blobUrl;' +
				        // opciono: revoke kasnije ako želiš
				        // setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
				        'return true;' +
				      '})' +
				      '.catch(() => false);' +
				  '}' +
				
				  // Ako fetch ne uspije, postavimo direktni URL i čekamo load/timeout
				  'tryFetchAsBlob().then(fetched => {' +
				    'if (!fetched) {' +
				      'usedBlob = false;' +
				      'iframe.src = pdfUrl;' +
				    '}' +
				    // sekundarni timeout: ako se ništa ne desi u roku 6s, pokaži fallback
				    'loadTimeout = setTimeout(() => {' +
				      'showFallback("iframe load timeout");' +
				    '}, 6000);' +
				  '});' +
				'})();</script>';
			}else{
				var prikazi = "<script> function doLoadCheck(){ $('.porukaUmjestoObjekta').hide(); $('.objectData').attr('width', '100%'); $('.objectData').attr('height', '100%'); }</script> <div class='porukaUmjestoObjekta'> Izvješće potražite u svom Preuzimanja/Downloads mapi/folderu. Hvala. <br> <a href='" + pdfUrl + "' target='_blank' rel='noopener noreferrer'>Otvori/preuzmi u novom tabu</a> </div> <div class='prikazi-datoteku1' style='height: 100%;'><object data='" + pdfUrl + "' type='application/pdf' width='1' height='1' onLoad=doLoadCheck() class='objectData' ></object></div>";
			}
			
			return prikazi;
		};
				
	